webpackJsonp([66],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by hoangnk on 2017/07/19.
 */

var LOCAL_HOST = 'http://localhost:8000/';
var TEST_HOST = 'https://test.timesheet-api.vtijapan.co.jp/';
var PRODUCTION_HOST = 'https://timesheet-api.vtijapan.co.jp/';
var UAT_HOST = 'http://uat-api.ts.vti.com.vn/';

var host = LOCAL_HOST;

if (false) {
  host = TEST_HOST;
} else if (true) {
  host = PRODUCTION_HOST;
} else if (process.env.NODE_ENV === 'uat') {
  host = UAT_HOST;
}
console.log("production");

var ROLE = {
  ADMIN: 1,
  TEAMLEAD: 2,
  MEMBER: 3,
  GROUPMANAGER: 4,
  ACCOUNTANT: 5,
  IINCHO: 6
};

module.exports = {
  LUNCH_TIME: '01:00', // default break time
  START_WORKING: '09:00', // default start time
  END_WORKING: '18:00', // default end time
  NORMAL_WORKING_TIME: 8.5, // calculate OT after 9.5h
  TOKEN_KEY: 'access_token', // key of data save in local storage
  EXPIRED_DATE: 'expired_date', // key of data save in local storage
  USER_PROFILE: 'user_profile', // key of data save in local storage
  SYSTEM_ERROR_MESSAGE: 'Sorry!!! System has error... Please contact to admin.', // message show when system has any error
  HOST: host,
  // role for user
  ROLE: ROLE,
  ALL_ROLE: [ROLE.ADMIN, ROLE.TEAMLEAD, ROLE.MEMBER, ROLE.GROUPMANAGER, ROLE.ACCOUNTANT, ROLE.IINCHO],
  // type off day off, same as DB and server
  DAY_OFF_TYPE: {
    ALLOWED: 1,
    LAST_YEAR: 2,
    SUMMER: 3,
    WEDDING: 5, // nghi cuoi
    FAMILY: 7, // viec hieu hi ruot thit
    RELATION: 8, // viec hieu, hy anh em ho hang
    WORKING: 9, // ngay lam viec
    HALF_DAY: 10, // nghi nua ngay
    JAPAN_HOLIDAY: 11, // nghi nua ngay
    WEEKEND: 12, // nghi nua ngay
    NOT_ALLOWED: 13, // nghi nua ngay
    SUBSTITUTE: 14 // nghi bu
  },
  DAY_OFF_NEED_ADMIN: 5, // if day off amount > this value admin will be required for approved
  DAY_OFF_TIME: {
    ALL_DAY: { 'id': 1, 'name': '全日' },
    MORNING: { 'id': 2, 'name': '午前' },
    AFTERNOON: { 'id': 3, 'name': '午後' }
  },
  // validation config for vee-validation
  VALIDATE_CONFIG: {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'field',
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true,
    classes: false,
    classNames: {
      touched: 'touched', // the control has been blurred
      untouched: 'untouched', // the control hasn't been blurred
      valid: 'valid', // model is valid
      invalid: 'invalid', // model is invalid
      pristine: 'pristine', // control has not been interacted with
      dirty: 'dirty' // control has been interacted with
    },
    events: 'input|blur',
    inject: true,
    validity: true,
    aria: true
  },

  OT_TYPE_WEEKEND: {
    SUBTITUDE_DAY_OFF: { 'id': 1, 'name': '代休' },
    OVERTIME: { 'id': 0, 'name': '残業' }
  },

  //   COMPANY_HOLIDAY: [
  //     {
  //       'date': {
  //         'day': 30,
  //         'month': 12,
  //         'year': 2019,
  //         'dayOfWeek': 1
  //       },
  //       'localName': '年末休暇 Nenmatsunenshi',
  //       'englishName': `New Year's Eve`
  //     },
  //     {
  //       'date': {
  //         'day': 31,
  //         'month': 12,
  //         'year': 2019,
  //         'dayOfWeek': 2
  //       },
  //       'localName': '年末休暇 Nenmatsunenshi',
  //       'englishName': `New Year's Eve`
  //     },
  //     {
  //       'date': {
  //         'day': 2,
  //         'month': 1,
  //         'year': 2020,
  //         'dayOfWeek': 4
  //       },
  //       'localName': '年始休暇 Nenmatsunenshi',
  //       'englishName': `New Year's Day`
  //     },
  //     {
  //       'date': {
  //         'day': 3,
  //         'month': 1,
  //         'year': 2020,
  //         'dayOfWeek': 5
  //       },
  //       'localName': '年始休暇 Nenmatsunenshi',
  //       'englishName': `New Year's Day`
  //     },
  //     {
  //       'date': {
  //         'day': 30,
  //         'month': 4,
  //         'year': 2019,
  //         'dayOfWeek': 2
  //       },
  //       'localName': '国民の休日 Kokuminnokyujitsu',
  //       'englishName': 'National Holiday'
  //     },
  //     {
  //       'date': {
  //         'day': 1,
  //         'month': 5,
  //         'year': 2019,
  //         'dayOfWeek': 3
  //       },
  //       'localName': '即位の日 Sokuinohi',
  //       'englishName': 'Day of Throne'
  //     },
  //     {
  //       'date': {
  //         'day': 2,
  //         'month': 5,
  //         'year': 2019,
  //         'dayOfWeek': 4
  //       },
  //       'localName': '国民の休日 Kokuminnokyujitsu',
  //       'englishName': 'National Holiday'
  //     },
  //     {
  //       'date': {
  //         'day': 22,
  //         'month': 10,
  //         'year': 2019,
  //         'dayOfWeek': 2
  //       },
  //       'localName': '即位礼正殿の儀',
  //       'englishName': ''
  //     }
  //   ],

  COMPANY_HOLIDAY: [{
    'summary': '年末休暇',
    'start': {
      'date': '2023-12-29'
    }
  }, {
    'summary': '年始休暇',
    'start': {
      'date': '2024-01-02'
    }
  }, {
    'summary': '年始休暇',
    'start': {
      'date': '2024-01-03'
    }
  }, {
    'summary': '振替休日',
    'start': {
      'date': '2024-05-06'
    }
  }, {
    'summary': '年末休暇',
    'start': {
      'date': '2024-12-30'
    }
  }],

  EXCLUSION_HOLIDAY: [{
    date: "2024-11-15"
  }, {
    date: "2025-03-03"
  }],

  BUDGET_TYPE: {
    'CERTIFICATE': 1,
    'SEMINAR': 2,
    'BOOK': 3,
    'OTHER': 4
  },

  STATUS: {
    'PENDING': 0,
    'APPROVED': 1,
    'REJECTED': 2,
    'CANCELED': 3
  },

  GOOGLE_CLIENT_ID: '75443299773-pc300f6hal6j57qq6bp2siadi78sj3u5.apps.googleusercontent.com',
  GOOGLE_CALENDAR_API_KEY: 'AIzaSyDzJP-WCAhbQBNl4QbRZQKyL2B0LCQcjlE'
};

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
exports.default = function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(229)("./" + name + (index ? '/index' : '') + '.vue');
  };
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(32);

var _stringify2 = _interopRequireDefault(_stringify);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(64);

var _index4 = _interopRequireDefault(_index3);

var _mutationTypes = __webpack_require__(16);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _userservice = __webpack_require__(48);

var _userservice2 = _interopRequireDefault(_userservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// URL and endpoint constants
/* const API_URL = 'http://localhost:3000/'
const LOGIN_URL = API_URL + 'sessions/create/'
const SIGNUP_URL = API_URL + 'users/' */

var HOST_URL = _globalservice2.default.HOST;
var CONFIRM_PASSWORD_URL = HOST_URL + 'api/confirmPassword';
var LOGIN_URL = HOST_URL + 'api/login';
var CHANGE_PASSWORD_URL = HOST_URL + 'api/changePassword';
var RESET_PASSWORD = HOST_URL + 'api/password/reset';
var SEND_MAIL_FORGOT_PASSWORD = HOST_URL + 'api/password/forgot';
var RESET_FORGOT_PASSWORD = HOST_URL + 'api/password/newPassword';
var VERIFY_FORGOT_PASSWORD_REQUEST = HOST_URL + 'api/tokenMail/resetPassword/';
var GOOGLE_LOGIN_URL = HOST_URL + 'api/googleLogin';

exports.default = {

  user: {
    authenticated: false
  },

  login: function login(context, creds, redirect) {
    var googleLogin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    context.$http.post(googleLogin ? GOOGLE_LOGIN_URL : LOGIN_URL, creds).then(function (response) {
      var data = response.data;
      if (data.status === 'success') {
        window.localStorage.setItem(_globalservice2.default.TOKEN_KEY, data.data.token);
        window.localStorage.setItem(_globalservice2.default.EXPIRED_DATE, data.data.expiredDate);
        window.localStorage.setItem(_globalservice2.default.USER_PROFILE, (0, _stringify2.default)(data.data.user));
        _index2.default.commit(_mutationTypes.AUTHENTICATED, true);
        _index4.default.push(redirect);
      } else if (redirect) {
        context.error = data.message;
      }
    }).catch(function () {
      context.error = 'System has error. Please contact admin for more information.';
    });
  },
  signup: function signup(context, creds, redirect) {
    /* context.$http.post(SIGNUP_URL, creds, (data) => {
      localStorage.setItem('id_token', data.id_token)
       this.user.authenticated = true
       if(redirect) {
        router.go(redirect)
      }
     }).error((err) => {
      context.error = err
    }) */
  },
  confirmPassword: function confirmPassword(context, data, callback, redirect) {
    var self = this;
    context.$http.post(CONFIRM_PASSWORD_URL, data, {
      headers: {
        Authorization: self.getAuthHeader()
      }
    }).then(function (response) {
      var data = response.data;

      if (data.status === 'success') {
        context.error = '';
        callback(response);
        _index4.default.push(redirect);
      } else {
        context.error = data.message;
      }
    }).catch(function (err) {
      context.error = err;
    });
  },
  changePassword: function changePassword(context, data, callback, error) {
    var self = this;
    context.$http.post(CHANGE_PASSWORD_URL, data, {
      headers: {
        Authorization: self.getAuthHeader()
      }
    }).then(function (response) {
      var data = response.data;
      if (data.status === 'success') {
        window.localStorage.setItem(_globalservice2.default.TOKEN_KEY, data.data.token);
        window.localStorage.setItem(_globalservice2.default.EXPIRED_DATE, data.data.expiredDate);
        callback(response);
      } else {
        context.error = data.message;
      }
    }).catch(function (err) {
      context.error = err;
    });
  },
  resetPassword: function resetPassword(context, data, callback, error) {
    var self = this;
    context.$http.post(RESET_PASSWORD, data, {
      headers: {
        Authorization: self.getAuthHeader()
      }
    }).then(function (response) {
      console.log(response.data);
      if (response.data.status === 'success') {
        callback(response.data);
      } else {
        error(response.data);
      }
    }).catch(function (err) {
      error(err);
    });
  },
  sendMailForgotPassword: function sendMailForgotPassword(context, creds, callback) {
    context.$http.post(SEND_MAIL_FORGOT_PASSWORD, creds).then(function (response) {
      callback(response.data);
    }).catch(function () {
      context.error = 'System has error. Please contact admin for more information.';
    });
  },
  resetForgotPassword: function resetForgotPassword(context, data, callback) {
    context.$http.post(RESET_FORGOT_PASSWORD, { data: (0, _stringify2.default)(data) }).then(function (response) {
      callback(response.data);
    }).catch(function () {
      context.error = 'System has error. Please contact admin for more information.';
    });
  },
  verifyForgotPasswordRequest: function verifyForgotPasswordRequest(context, token, callback) {
    context.$http.get(VERIFY_FORGOT_PASSWORD_REQUEST + token).then(function (response) {
      var data = response.data;
      callback(data);
    }).catch(function () {
      context.error = 'System has error. Please contact admin for more information.';
    });
  },
  logout: function logout() {
    window.localStorage.removeItem(_globalservice2.default.TOKEN_KEY);
    window.localStorage.removeItem(_globalservice2.default.EXPIRED_DATE);
    window.localStorage.removeItem(_globalservice2.default.USER_PROFILE);
    window.localStorage.removeItem('checkInAt');
    _index2.default.commit(_mutationTypes.AUTHENTICATED, false);
    _index4.default.push('/login');
  },
  checkAuth: function checkAuth() {
    /* var jwt = localStorage.getItem('id_token')
    if(jwt) {
      this.user.authenticated = true
    }
    else {
      this.user.authenticated = false
    } */
  },
  getAuthHeader: function getAuthHeader() {
    return 'Bearer ' + window.localStorage.getItem(_globalservice2.default.TOKEN_KEY);
  },
  getIdToken: function getIdToken() {
    return window.localStorage.getItem(_globalservice2.default.TOKEN_KEY);
  },
  getTokenExpiredDate: function getTokenExpiredDate() {
    return new Date(window.localStorage.getItem(_globalservice2.default.EXPIRED_DATE));
  },
  isLoggedIn: function isLoggedIn() {
    var idToken = this.getIdToken();
    return !!idToken && !this.isTokenExpired(idToken);
  },
  isTokenExpired: function isTokenExpired() {
    var expirationDate = this.getTokenExpiredDate();
    return expirationDate < new Date();
  },
  requireAuth: function requireAuth(to, from, next) {
    _index2.default.commit(_mutationTypes.EVENT_COUNT);
    if (to.name === 'Permission Deny' || to.name === '404 Not Found' || to.name === 'Login' || to.name === 'Forgot Password' || to.name === 'Reset Password') {
      next();
    }

    if (!this.isLoggedIn()) {
      switch (to.name) {
        case 'Forgot Password':
          next({
            path: '/forgotPassword'
          });
          break;

        case 'Reset Password':
          next();
          break;

        default:
          next({
            path: '/login'
          });
      }
    } else {
      // check authorization
      var role = _userservice2.default.getUserProfile().role;
      var roleAccept = to.meta.roles || [];
      var index = roleAccept.indexOf(role);
      if (to.name === 'Login') {
        if (from.name === 'Reset Password') {
          this.logout();
        } else {
          next({
            path: '/login'
          });
        }
      } else if (to.name === 'Reset Password') {
        next();
      } else if (index !== -1) {
        _index2.default.commit(_mutationTypes.AUTHENTICATED, true);
        next();
      } else {
        next({
          path: '/permissionDeny'
        });
      }
    }
  }
};

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_DEVICE = exports.TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = exports.TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = exports.EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = exports.SWITCH_EFFECT = 'SWITCH_EFFECT';

var AUTHENTICATED = exports.AUTHENTICATED = 'authenticated';

var TIMESHEET_PAGE = exports.TIMESHEET_PAGE = 'timesheetPage';

var EVENT_COUNT = exports.EVENT_COUNT = 'EVENT_COUNT';

var TIMESHEET_STATUS = exports.TIMESHEET_STATUS = 'timesheetStatus';

var DATETIME_TIMESHEET = exports.DATETIME_TIMESHEET = 'datetimemytimesheet';

var DATETIME_OTSTATUS = exports.DATETIME_OTSTATUS = 'datetimeotstatus';

var DATETIME_TOTALOT = exports.DATETIME_TOTALOT = 'datetimetotalot';

var DATETIME_TIMESHEETLIST = exports.DATETIME_TIMESHEETLIST = 'datetimetimesheetlist';

var ALLOWANCE_SWITCH = exports.ALLOWANCE_SWITCH = 'allowanceSwitch';

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/vti.5f9cd6d.png";

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(333)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(379),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(3);

var _vuex2 = _interopRequireDefault(_vuex);

var _package = __webpack_require__(383);

var _package2 = _interopRequireDefault(_package);

var _actions = __webpack_require__(251);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(227);

var getters = _interopRequireWildcard(_getters);

var _app = __webpack_require__(252);

var _app2 = _interopRequireDefault(_app);

var _menu = __webpack_require__(65);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: actions,
  getters: getters,
  modules: {
    app: _app2.default,
    menu: _menu2.default
  },
  state: {
    pkg: _package2.default,
    authenticated: false
  },
  mutations: {}
});

exports.default = store;

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(32);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = __webpack_require__(15);
var authService = __webpack_require__(9);
var User = __webpack_require__(228);
var Global = __webpack_require__(2);
// var axios = require('axios')

var GET_TEAM_LEAD_URL = Global.HOST + 'api/user/getTeamLead';
var GET_USER_DETAIL_URL = Global.HOST + 'api/user/getUserDetail';
var GET_ALL_ROLE_URL = Global.HOST + 'api/role/getAllRole';
var GET_POST_CODE_URL = Global.HOST + 'api/postCode/getPostCode';
var CREATE_UPDATE_USER_URL = Global.HOST + 'api/user/createUpdateUserInfo';
var GET_ALL_GROUP_MANAGER = Global.HOST + 'api/user/getAllGroupManager';
var GET_GROUP_MANAGER = Global.HOST + 'api/user/getGroupManagerOfUser';
var GET_OT_APPROVER = Global.HOST + 'api/user/getShinseiOTApprover';
var GET_ADMIN = Global.HOST + 'api/user/getAllAdmin';
var DELETE_USER_URL = Global.HOST + 'api/user/delete';
var GET_ALL_CHANGE_PROFILE_REQUEST = Global.HOST + 'api/user/getAllChangeProfileRequest';
var APPROVE_USER_REQUEST = Global.HOST + 'api/user/approve';
var REJECT_USER_REQUEST = Global.HOST + 'api/user/reject';
var GET_REQUEST_BY_USER_AND_STATUS = Global.HOST + 'api/user/getRequestByUserAndStatus';

exports.default = {
  getTeamLead: function getTeamLead(callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_TEAM_LEAD_URL,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response.data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  getAllGroupManager: function getAllGroupManager(callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_ALL_GROUP_MANAGER,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response.data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  getAllAdmin: function getAllAdmin(callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_ADMIN,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response.data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  getGroupManagerOfUser: function getGroupManagerOfUser(callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_GROUP_MANAGER,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response.data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  // get all GM and 委員長 who can accept OT request
  getShinseiOTApprover: function getShinseiOTApprover(callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_OT_APPROVER,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response.data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  getUserDetail: function getUserDetail(id, callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_USER_DETAIL_URL,
      data: {
        'id': id
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          var userProfile = new User.UserProfile(response.data);
          callback(userProfile);
        } else {
          error(response.message);
        }
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  getAllRole: function getAllRole(callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_ALL_ROLE_URL,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response);
        } else {
          error(response.message);
        }
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  getPostCode: function getPostCode(code, callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_POST_CODE_URL + '/' + code,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          error(response.message);
        }
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  createOrUpdateUserInfo: function createOrUpdateUserInfo(method, data, avatarFile, callback, _error) {
    var file = new window.FormData();
    file.append('data', (0, _stringify2.default)(data));
    file.append('method', method);
    file.append('avatar', avatarFile);
    $.ajax({
      method: 'POST',
      url: CREATE_UPDATE_USER_URL,
      data: file,
      processData: false,
      contentType: false,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          _error(response.message);
        }
      },
      error: function error(err) {
        _error(err);
      }
    });
  },

  deleteUser: function deleteUser(userId, callback, _error2) {
    $.ajax({
      method: 'POST',
      url: DELETE_USER_URL + '/' + userId,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          _error2(response.message);
        }
      },
      error: function error(err) {
        _error2(err);
      }
    });
  },

  getAllChangeProfileRequest: function getAllChangeProfileRequest(callback, error) {
    $.ajax({
      method: 'GET',
      url: GET_ALL_CHANGE_PROFILE_REQUEST,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response.data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  approveUserRequest: function approveUserRequest(data, callback, error) {
    $.ajax({
      method: 'POST',
      url: APPROVE_USER_REQUEST,
      data: {
        data: (0, _stringify2.default)(data)
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          error(response);
        }
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  rejectUserRequest: function rejectUserRequest(data, callback, error) {
    $.ajax({
      method: 'POST',
      url: REJECT_USER_REQUEST,
      data: {
        data: (0, _stringify2.default)(data)
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          error(response);
        }
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  getRequestByUserAndStatus: function getRequestByUserAndStatus(data, callback, error) {
    $.ajax({
      method: 'POST',
      url: GET_REQUEST_BY_USER_AND_STATUS,
      data: {
        data: (0, _stringify2.default)(data)
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response.data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },

  getUserProfile: function getUserProfile() {
    return JSON.parse(window.localStorage.getItem('user_profile'));
  },

  setUserProfile: function setUserProfile(userProfile) {
    window.localStorage.setItem('user_profile', (0, _stringify2.default)(userProfile));
  }
};

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterBar = exports.Levelbar = exports.AppMain = exports.Sidebar = exports.Navbar = undefined;

var _Navbar2 = __webpack_require__(346);

var _Navbar3 = _interopRequireDefault(_Navbar2);

var _Sidebar2 = __webpack_require__(347);

var _Sidebar3 = _interopRequireDefault(_Sidebar2);

var _AppMain2 = __webpack_require__(344);

var _AppMain3 = _interopRequireDefault(_AppMain2);

var _Levelbar2 = __webpack_require__(193);

var _Levelbar3 = _interopRequireDefault(_Levelbar2);

var _FooterBar2 = __webpack_require__(345);

var _FooterBar3 = _interopRequireDefault(_FooterBar2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Navbar = _Navbar3.default;
exports.Sidebar = _Sidebar3.default;
exports.AppMain = _AppMain3.default;
exports.Levelbar = _Levelbar3.default;
exports.FooterBar = _FooterBar3.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(221);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _authenticationservice = __webpack_require__(9);

var _authenticationservice2 = _interopRequireDefault(_authenticationservice);

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(37);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _menu = __webpack_require__(65);

var _menu2 = _interopRequireDefault(_menu);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    name: 'Login',
    path: '/login',
    component: __webpack_require__(202)
  }, {
    name: 'Forgot Password',
    path: '/forgotPassword',
    component: __webpack_require__(200)
  }, {
    name: 'Reset Password',
    path: '/resetPassword/:token',
    component: __webpack_require__(201)
  }, {
    path: '/',
    component: __webpack_require__(194),
    children: [{
      name: 'Home',
      path: 'home',
      alias: '',
      component: __webpack_require__(195),
      meta: {
        roles: _globalservice2.default.ALL_ROLE
      }
    }, {
      name: 'Permission Deny',
      path: 'permissionDeny',
      component: __webpack_require__(198),
      meta: {
        roles: _globalservice2.default.ALL_ROLE
      }
    }, {
      name: '404 Not Found',
      path: 'notFound',
      component: __webpack_require__(197),
      meta: {
        roles: _globalservice2.default.ALL_ROLE
      }
    }, {
      name: 'Preview Timesheet',
      path: '/timesheet/preview/:month/:year/:id',
      component: __webpack_require__(203),
      meta: {
        roles: _globalservice2.default.ALL_ROLE
      }

    }, {
      name: 'Confirm Password',
      path: '/confirmPassword',
      component: __webpack_require__(199),
      meta: {
        roles: _globalservice2.default.ALL_ROLE
      }
    }].concat((0, _toConsumableArray3.default)(generateRoutesFromMenu(_menu2.default.state.items)))
    // beforeEnter: function (to, from, next) {
    //   authService.requireAuth(to, from, next)
    // }
  }, {
    path: '*',
    redirect: '/notFound'
  }]
});

router.beforeEach(function (to, from, next) {
  _authenticationservice2.default.requireAuth(to, from, next);
});

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

exports.default = router;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutationTypes = __webpack_require__(16);

var types = _interopRequireWildcard(_mutationTypes);

var _timesheet = __webpack_require__(262);

var _timesheet2 = _interopRequireDefault(_timesheet);

var _mailPayment = __webpack_require__(258);

var _mailPayment2 = _interopRequireDefault(_mailPayment);

var _user = __webpack_require__(263);

var _user2 = _interopRequireDefault(_user);

var _team = __webpack_require__(261);

var _team2 = _interopRequireDefault(_team);

var _changePassword = __webpack_require__(255);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _dayoff = __webpack_require__(256);

var _dayoff2 = _interopRequireDefault(_dayoff);

var _general = __webpack_require__(257);

var _general2 = _interopRequireDefault(_general);

var _payslip = __webpack_require__(260);

var _payslip2 = _interopRequireDefault(_payslip);

var _news = __webpack_require__(259);

var _news2 = _interopRequireDefault(_news);

var _budget = __webpack_require__(254);

var _budget2 = _interopRequireDefault(_budget);

var _allowance = __webpack_require__(253);

var _allowance2 = _interopRequireDefault(_allowance);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [_timesheet2.default, _dayoff2.default, _user2.default, _team2.default, _payslip2.default, _allowance2.default, _changePassword2.default]
};

var mutations = (0, _defineProperty3.default)({}, types.EXPAND_MENU, function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

exports.default = {
  state: state,
  mutations: mutations
};

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(367),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(327)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(372),
  /* scopeId */
  "data-v-7a97aea1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  "data-v-2da5f88e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(361),
  /* scopeId */
  "data-v-1877dba4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(369),
  /* scopeId */
  "data-v-63b534f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(329)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(374),
  /* scopeId */
  "data-v-7fded592",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(368),
  /* scopeId */
  "data-v-5a99a50c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(377),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(247);

_app.app.$mount('#app');

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(0);
var axiosinstance = __webpack_require__(49);
module.exports = {
  timeFormat: function timeFormat(time) {
    var timeFormat = moment(time, 'HH:mm:ss');
    return time ? timeFormat.format('HH:mm') : '';
  },
  convertHourStringToMinute: function convertHourStringToMinute(str) {
    var time = moment(str, 'HH:mm');
    return Number(time.hours() * 60 + time.minutes());
  },
  convertHourStringToHour: function convertHourStringToHour(str) {
    var time = moment(str, 'HH:mm');
    return Number(time.hours() + time.minutes() / 60).toFixed(2);
  },


  minutesToHhMm: function minutesToHhMm(mins) {
    return moment.utc().startOf('day').add(mins, 'minutes').format('HH:mm');
  },

  timeBetween: function timeBetween(start, end) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'm';

    return end.diff(start, unit);
  },

  // calculate real working time in minute
  getTimeSpendInMinute: function getTimeSpendInMinute(start, end, lunchTime) {
    var endRange = moment('05:00', 'HH:mm');
    var time = 0;

    var rangeTime = this.timeBetween(start, end);
    if (lunchTime >= Math.abs(rangeTime) / 60) {
      return 0;
    }

    if (rangeTime <= 0 && this.timeBetween(endRange, end) <= 0) {
      time = rangeTime + 24 * 60;
    } else if (rangeTime > 0) {
      time = rangeTime;
    }
    var NORMAL_LUNCH_HOURS = lunchTime * 60;
    return time - NORMAL_LUNCH_HOURS;
  },

  // get year holiday of country in range time from ~ to
  // from and to value in DD-MM-YYYY format
  getYearHoliday: function getYearHoliday(from, to, country, callback) {
    return axiosinstance.get('//kayaposoft.com/enrico/json/v1.0/?action=getPublicHolidaysForDateRange&fromDate=' + from + '&toDate=' + to + '&country=' + country, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      callback(response.data);
    }).catch(function (error) {
      console.log('failed with error: ' + error);
    });
  },


  // round working time to calculate OT time
  // input in format HH:mm
  roundWorkingTime: function roundWorkingTime(stringTime) {
    var minTime = this.convertHourStringToMinute(stringTime);
    var blockMinute = 15; // round to block 15 minutes
    minTime = Math.floor(minTime / blockMinute) * blockMinute;
    return this.minutesToHhMm(minTime);
  },
  empty: function empty(value) {
    return !value || value === '' || value === 0 || value === '0' || value === 0.0 || value === [] || value === {};
  }
};

/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(32);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = __webpack_require__(15);
var TimesheetList = __webpack_require__(249);
var Global = __webpack_require__(2);
var authService = __webpack_require__(9);
// var axios = require('axios')

var TIMESHEET_URL = Global.HOST + 'api/timesheet/getTimesheet';
var SAVE_TIMESHEET_URL = Global.HOST + 'api/timesheet/saveTimesheetOfUser';
var SHINSEI_OT_URL = Global.HOST + 'api/timesheet/shinseiOT';
var GET_TOKEN_EXPORT_EXCEL_URL = Global.HOST + 'api/timesheet/getExcelExportToken';
var GET_SHINSET_HISTORY_TIME_URL = Global.HOST + 'api/shinseiOT/getShinseiHistoryTime';
var CREATE_TIMESHEET_ZIP_FILE = Global.HOST + 'api/timesheet/createTimesheetZipFile';
var GET_PREVIEW_TIMESHEET = Global.HOST + 'api/timesheet/getPreviewTimeSheet';
var GET_TIMESHEET_STATUS_OF_USER = Global.HOST + 'api/timesheet/getTimesheetStatusOfUser';
var SUBMIT_TIMESHEET = Global.HOST + 'api/timesheet/submitPreviewTimesheet';
var APPROVE_TIMESHEET = Global.HOST + 'api/timesheet/approvePreviewTimesheet';
var REJECT_TIMESHEET = Global.HOST + 'api/timesheet/rejectPreviewTimesheet';
var ACCEPT_OT_REQUEST = Global.HOST + 'api/tokenMail/acceptOT';
var REJECT_OT_REQUEST = Global.HOST + 'api/tokenMail/rejectOT';
var APPROVE_ALL_OT_REQUEST = Global.HOST + 'api/tokenMail/acceptAllOTShinsei';
var REJECT_ALL_OT_REQUEST = Global.HOST + 'api/tokenMail/rejectAllOTShinsei';
var GET_TOKEN_MAIL_BY_SHINSEI_ID = Global.HOST + 'api/tokenMail/getTokenByShinseiId';

module.exports = {
  // get List Timesheet data of a user
  getListOf: function getListOf(condition, callback, error) {
    return $.ajax({
      method: 'GET',
      url: TIMESHEET_URL,
      data: condition,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        var timesheet = new TimesheetList(response.data);

        callback(timesheet);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },
  // save timesheet of a user
  saveList: function saveList(data, userID, callback, _error) {
    $.ajax({
      method: 'POST',
      url: SAVE_TIMESHEET_URL,
      data: {
        data: (0, _stringify2.default)(data),
        user_id: userID
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response);
      },
      error: function error(err) {
        _error(err);
      }
    });
  },
  // send shinseiOT requet
  shinseiOT: function shinseiOT(data, callback, _error2) {
    $.ajax({
      method: 'POST',
      url: SHINSEI_OT_URL,
      data: { 'data': (0, _stringify2.default)(data) },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response);
      },
      error: function error(err) {
        _error2(err);
      }
    });
  },

  // get token to export excel
  getTokenExportExcel: function getTokenExportExcel(callback, _error3) {
    $.ajax({
      method: 'GET',
      url: GET_TOKEN_EXPORT_EXCEL_URL,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response);
      },
      error: function error(err) {
        _error3(err);
      }
    });
  },
  // get shinsei OT history time of user
  getShinseiHistoryTime: function getShinseiHistoryTime(workingDate, callback, _error4) {
    $.ajax({
      method: 'GET',
      data: {
        'working_date': workingDate
      },
      url: GET_SHINSET_HISTORY_TIME_URL,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response);
      },
      error: function error(err) {
        _error4(err);
      }
    });
  },
  // send request to create timesheet .zip file on server, and request forlder name
  createTimesheetZipFile: function createTimesheetZipFile(month, year, callback, _error5) {
    $.ajax({
      method: 'POST',
      data: {
        'month': month,
        'year': year
      },
      url: CREATE_TIMESHEET_ZIP_FILE,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response);
        } else {
          _error5(response);
        }
      },
      error: function error(err) {
        _error5(err);
      }
    });
  },

  getPreviewTimesheet: function getPreviewTimesheet(userId, month, year, callback, _error6) {
    $.ajax({
      method: 'GET',
      data: {
        'user_id': userId,
        'month': month,
        'year': year
      },
      url: GET_PREVIEW_TIMESHEET,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        callback(response);
      },
      error: function error(err) {
        _error6(err);
      }
    });
  },

  getTimesheetStatusOfUser: function getTimesheetStatusOfUser(timesheet, callback, _error7) {
    $.ajax({
      method: 'POST',
      data: { data: (0, _stringify2.default)(timesheet) },
      url: GET_TIMESHEET_STATUS_OF_USER,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response);
        } else {
          _error7(response);
        }
      },
      error: function error(err) {
        _error7(err);
      }
    });
  },

  submitTimesheet: function submitTimesheet(timesheet, callback, _error8) {
    $.ajax({
      method: 'POST',
      data: { data: (0, _stringify2.default)(timesheet) },
      url: SUBMIT_TIMESHEET,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response);
        } else {
          _error8(response);
        }
      },
      error: function error(err) {
        _error8(err);
      }
    });
  },

  approveTimesheet: function approveTimesheet(timesheet, callback, _error9) {
    $.ajax({
      method: 'POST',
      data: { data: (0, _stringify2.default)(timesheet) },
      url: APPROVE_TIMESHEET,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response);
        } else {
          _error9(response);
        }
      },
      error: function error(err) {
        _error9(err);
      }
    });
  },

  rejectTimesheet: function rejectTimesheet(timesheet, callback, _error10) {
    $.ajax({
      method: 'POST',
      data: { data: (0, _stringify2.default)(timesheet) },
      url: REJECT_TIMESHEET,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response);
        } else {
          _error10(response);
        }
      },
      error: function error(err) {
        _error10(err);
      }
    });
  },

  getTokenMailByShinseiId: function getTokenMailByShinseiId(dayoffId, callback, _error11) {
    $.ajax({
      method: 'POST',
      url: GET_TOKEN_MAIL_BY_SHINSEI_ID,
      data: { id: dayoffId },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          _error11(response);
        }
      },
      error: function error(err) {
        _error11(err);
      }
    });
  },

  approveRejectOTRequest: function approveRejectOTRequest(action, token, callback, _error12) {
    var url = action === 'approve' ? ACCEPT_OT_REQUEST : REJECT_OT_REQUEST;
    $.ajax({
      method: 'GET',
      url: url + '/' + token + '/0',
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          _error12(response);
        }
      },
      error: function error(err) {
        _error12(err);
      }
    });
  },

  approveAllOtShinseiRequest: function approveAllOtShinseiRequest(data, callback, _error13) {
    var url = APPROVE_ALL_OT_REQUEST;
    $.ajax({
      method: 'POST',
      data: data,
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          _error13(response);
        }
      },
      error: function error(err) {
        _error13(err);
      }
    });
  },

  rejectAllOtShinseiRequest: function rejectAllOtShinseiRequest(data, callback, _error14) {
    var url = REJECT_ALL_OT_REQUEST;
    $.ajax({
      method: 'POST',
      data: data,
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', authService.default.getAuthHeader());
      },
      success: function success(response) {
        if (response.status === 'success') {
          callback(response.data);
        } else {
          _error14(response);
        }
      },
      error: function error(err) {
        _error14(err);
      }
    });
  }
};

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/loading.79deed6.gif";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var authenticated = function authenticated(state) {
  return state.app.authenticated;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var timesheetPage = function timesheetPage(state) {
  return state.app.timesheetPage;
};
var allowanceSwitch = function allowanceSwitch(state) {
  return state.app.allowanceSwitch;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};
var eventcount = function eventcount(state) {
  return state.app.eventCount;
};
var timesheetStatus = function timesheetStatus(state) {
  return state.app.timesheetStatus;
};
var datetimeTimesheet = function datetimeTimesheet(state) {
  return state.app.datetimemytimesheet;
};
var datetimeOTStatus = function datetimeOTStatus(state) {
  return state.app.datetimeotstatus;
};
var datetimeTotalOT = function datetimeTotalOT(state) {
  return state.app.datetimetotalot;
};
var datetimeTimesheetList = function datetimeTimesheetList(state) {
  return state.app.datetimetimesheetlist;
};

exports.pkg = pkg;
exports.app = app;
exports.authenticated = authenticated;
exports.device = device;
exports.sidebar = sidebar;
exports.effect = effect;
exports.menuitems = menuitems;
exports.timesheetPage = timesheetPage;
exports.componententry = componententry;
exports.eventcount = eventcount;
exports.timesheetStatus = timesheetStatus;
exports.datetimeTimesheet = datetimeTimesheet;
exports.datetimeOTStatus = datetimeOTStatus;
exports.datetimeTotalOT = datetimeTotalOT;
exports.datetimeTimesheetList = datetimeTimesheetList;
exports.allowanceSwitch = allowanceSwitch;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(33);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = __webpack_require__(15);

function UserProfile(raw) {
    UserProfile.prototype.init.call(this, raw);
}

$.extend(UserProfile.prototype, {
    id: null,
    user_code: null,
    first_name: null,
    last_name: null,
    sex: null,
    email: null,
    contract_type: null,
    start_from: null,
    working_site: null,
    address: null,
    post_code: null,
    phone_number: null,
    dob: null,
    start_working_time: null,
    end_working_time: null,
    break_time: null,
    group: null,
    team: null,
    role: null,
    avatar: null,
    quick_contact_name: null,
    quick_contact_phone: null,
    quick_contact_address: null,
    quick_contact_relation: null,
    quick_contact_name_vn: null,
    quick_contact_phone_vn: null,
    quick_contact_address_vn: null,
    quick_contact_relation_vn: null,
    insurance_health: null,
    insurance_welfare: null,
    insurance_employment: null,
    insurance_member: null,
    relation: null,
    old_working_place: null,
    car_ticket: null,
    furigana_name: null,
    address_vn: null,
    user_skill: null,
    user_certificate: null,

    init: function init(raw) {
        var self = this;

        self.user_code = raw && raw.user_code ? raw.user_code : null;
        self.id = raw && raw.id ? raw.id : null;
        self.first_name = raw && raw.first_name ? raw.first_name : null;
        self.last_name = raw && raw.last_name ? raw.last_name : null;
        self.furigana_name = raw && raw.furigana_name ? raw.furigana_name : null;
        self.sex = raw && raw.sex !== undefined ? raw.sex : null;
        self.email = raw && raw.email ? raw.email : null;
        self.contract_type = raw && raw.contract_type ? raw.contract_type : null;
        self.start_from = raw && raw.start_from ? raw.start_from : null;
        self.working_site = raw && raw.working_site ? raw.working_site : null;
        self.old_working_place = raw && raw.old_working_place ? raw.old_working_place : null;
        self.address = raw && raw.address ? raw.address : null;
        self.address_vn = raw && raw.address_vn ? raw.address_vn : null;
        self.post_code = raw && raw.post_code ? raw.post_code : null;
        self.phone_number = raw && raw.phone_number ? raw.phone_number : null;
        self.dob = raw && raw.dob ? raw.dob : null;
        self.start_working_time = raw && raw.start_working_time ? raw.start_working_time : null;
        self.end_working_time = raw && raw.end_working_time ? raw.end_working_time : null;
        self.break_time = raw && (raw.break_time || raw.break_time === 0) ? raw.break_time : null;
        self.user_role = raw && raw.user_role ? raw.user_role : {};
        self.car_ticket = raw && raw.car_ticket ? raw.car_ticket : null;
        self.user_team = raw && raw.user_team ? raw.user_team : {};
        self.avatar = raw && raw.avatar ? raw.avatar : null;
        self.vti_group = raw && raw.vti_group ? raw.vti_group : null;
        self.quick_contact_address = raw && raw.quick_contact_address ? raw.quick_contact_address : null;
        self.quick_contact_name = raw && raw.quick_contact_name ? raw.quick_contact_name : null;
        self.quick_contact_phone = raw && raw.quick_contact_phone ? raw.quick_contact_phone : null;
        self.quick_contact_relation = raw && raw.quick_contact_relation ? raw.quick_contact_relation : null;
        self.quick_contact_address_vn = raw && raw.quick_contact_address_vn ? raw.quick_contact_address_vn : null;
        self.quick_contact_name_vn = raw && raw.quick_contact_name_vn ? raw.quick_contact_name_vn : null;
        self.quick_contact_phone_vn = raw && raw.quick_contact_phone_vn ? raw.quick_contact_phone_vn : null;
        self.quick_contact_relation_vn = raw && raw.quick_contact_relation_vn ? raw.quick_contact_relation_vn : null;
        self.insurance_welfare = raw && raw.insurance_welfare ? raw.insurance_welfare : null;
        self.insurance_member = raw && raw.insurance_member ? raw.insurance_member : null;
        self.insurance_employment = raw && raw.insurance_employment ? raw.insurance_employment : null;
        self.insurance_health = raw && raw.insurance_health ? raw.insurance_health : null;
        self.relation = raw && raw.relation ? raw.relation : [];
        self.user_skill = raw && raw.user_skill ? raw.user_skill : [];
        self.user_certificate = raw && raw.user_certificate ? raw.user_certificate : [];
        self.user_working_status = raw && raw.user_working_status ? raw.user_working_status : {};
    }
});

module.exports.UserProfile = UserProfile;

function UserProfileList(raw) {
    UserProfileList.prototype.init.call(this, raw);
}

$.extend(UserProfileList.prototype, {
    items: null,

    init: function init(raw) {
        var self = this;

        var items = [];

        if (raw) {
            for (var i = 0; i < (0, _keys2.default)(raw).length; i++) {
                items.push(raw[(0, _keys2.default)(raw)[i]]);
            }
        }

        self.items = items;
    },

    update: function update(raw) {
        var self = this;

        var items = [];

        for (var i = 0; i < (0, _keys2.default)(raw).length; i++) {
            items.push(raw[(0, _keys2.default)(raw)[i]]);
        }

        self.items = items;
    }
});

module.exports.UserProfileList = UserProfileList;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Budget/AllRequest.vue": [
		410,
		30
	],
	"./Budget/CreateRequest.vue": [
		411,
		33
	],
	"./Budget/MyRequest.vue": [
		412,
		27
	],
	"./Budget/Summary.vue": [
		413,
		26
	],
	"./Dash.vue": [
		194
	],
	"./Home.vue": [
		195
	],
	"./allowance/AllowanceAddNew.vue": [
		414,
		11
	],
	"./allowance/AllowanceSetting.vue": [
		415,
		37
	],
	"./allowance/AllowanceViewDraft.vue": [
		416,
		13
	],
	"./allowance/AllowanceViewList.vue": [
		417,
		12
	],
	"./components/Collapse.vue": [
		418,
		43
	],
	"./components/Datepicker.vue": [
		419,
		42
	],
	"./components/Default.vue": [
		420,
		48
	],
	"./components/Message.vue": [
		421,
		46
	],
	"./components/Modal.vue": [
		422,
		44
	],
	"./components/Notification.vue": [
		423,
		45
	],
	"./components/Tooltip.vue": [
		424,
		58
	],
	"./components/index.vue": [
		425,
		64
	],
	"./components/modals/AddCertificateModal.vue": [
		392,
		34
	],
	"./components/modals/AddRelationModal.vue": [
		393,
		41
	],
	"./components/modals/AddSkillModal.vue": [
		394,
		32
	],
	"./components/modals/AlertModal.vue": [
		23
	],
	"./components/modals/BudgetDetail.vue": [
		397,
		57
	],
	"./components/modals/CancelReasonModal.vue": [
		398,
		36
	],
	"./components/modals/CardModal.vue": [
		399,
		59
	],
	"./components/modals/CertificateModal.vue": [
		400,
		51
	],
	"./components/modals/ChooseAdminModal.vue": [
		395,
		56
	],
	"./components/modals/ConfirmModal.vue": [
		389,
		55
	],
	"./components/modals/ConfirmPaymentMailModal.vue": [
		401,
		40
	],
	"./components/modals/DayOffDetail.vue": [
		396,
		28
	],
	"./components/modals/DayoffRequestDetailRow.vue": [
		402,
		63
	],
	"./components/modals/DifferentInfoModal.vue": [
		403,
		39
	],
	"./components/modals/ImageModal.vue": [
		404,
		62
	],
	"./components/modals/LoadModal.vue": [
		21
	],
	"./components/modals/LoadModal_Allowance.vue": [
		391,
		54
	],
	"./components/modals/MessageModal.vue": [
		388,
		53
	],
	"./components/modals/Modal.vue": [
		405,
		61
	],
	"./components/modals/NewsModal.vue": [
		406,
		49
	],
	"./components/modals/NoteModal.vue": [
		196
	],
	"./components/modals/OTRequestDetailRow.vue": [
		407,
		60
	],
	"./components/modals/ShinseiOTModal.vue": [
		390,
		35
	],
	"./components/modals/SkillModal.vue": [
		408,
		50
	],
	"./components/modals/WorkingTimeModal.vue": [
		409,
		38
	],
	"./dashboard/index.vue": [
		426,
		52
	],
	"./dayOff/AllRequest.vue": [
		427,
		29
	],
	"./dayOff/ManagerRequest.vue": [
		428,
		17
	],
	"./dayOff/MyRequest.vue": [
		429,
		15
	],
	"./dayOff/RequestDayOff.vue": [
		430,
		10
	],
	"./dayOff/Summary.vue": [
		431,
		14
	],
	"./error/404NotFound.vue": [
		197
	],
	"./error/PermissionDeny.vue": [
		198
	],
	"./general/Certificate.vue": [
		432,
		23
	],
	"./general/Skill.vue": [
		433,
		22
	],
	"./login/ConfirmPassword.vue": [
		199
	],
	"./login/ForgotPassword.vue": [
		200
	],
	"./login/ResetPassword.vue": [
		201
	],
	"./login/index.vue": [
		202
	],
	"./mailPayment/MailPayment.vue": [
		434,
		1
	],
	"./mailPayment/MailStatus.vue": [
		435,
		5
	],
	"./mailPayment/MailTemplate.vue": [
		436,
		4
	],
	"./news/AllNews.vue": [
		437,
		21
	],
	"./payslip/MyPayslip.vue": [
		438,
		3
	],
	"./payslip/PayslipManager.vue": [
		439,
		2
	],
	"./payslip/PayslipUpload.vue": [
		440,
		31
	],
	"./team/AllTeam.vue": [
		441,
		16
	],
	"./timesheet/AbsenceList.vue": [
		442,
		7
	],
	"./timesheet/Newtimesheet.vue": [
		443,
		0
	],
	"./timesheet/OTManagerRequest.vue": [
		444,
		24
	],
	"./timesheet/OTRequest.vue": [
		445,
		9
	],
	"./timesheet/OTTotal.vue": [
		446,
		8
	],
	"./timesheet/Preview.vue": [
		203
	],
	"./timesheet/TimesheetList.vue": [
		447,
		6
	],
	"./user/AllRequest.vue": [
		448,
		20
	],
	"./user/ChangePassword.vue": [
		449,
		47
	],
	"./user/CreateNewUser.vue": [
		450,
		19
	],
	"./user/UserDetail.vue": [
		451,
		18
	],
	"./user/UserList.vue": [
		452,
		25
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 229;

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.router = exports.app = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(33);

var _keys2 = _interopRequireDefault(_keys);

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(49);

var _axios2 = _interopRequireDefault(_axios);

var _vueAxios = __webpack_require__(340);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _vueNprogress = __webpack_require__(380);

var _vueNprogress2 = _interopRequireDefault(_vueNprogress);

var _vuexRouterSync = __webpack_require__(42);

var _App = __webpack_require__(343);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(64);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(36);

var _store2 = _interopRequireDefault(_store);

var _filters = __webpack_require__(248);

var filters = _interopRequireWildcard(_filters);

var _textformat = __webpack_require__(250);

var _textformat2 = _interopRequireDefault(_textformat);

var _vueEvents = __webpack_require__(212);

var _vueEvents2 = _interopRequireDefault(_vueEvents);

var _vueJsToggleButton = __webpack_require__(342);

var _vueJsToggleButton2 = _interopRequireDefault(_vueJsToggleButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { TOGGLE_SIDEBAR } from 'vuex-store/mutation-types'

_vue2.default.router = _router2.default;
_vue2.default.use(_vueAxios2.default, _axios2.default);

_vue2.default.use(_vueNprogress2.default);

_vue2.default.use(_textformat2.default);

_vue2.default.use(_vueEvents2.default);

_vue2.default.use(_vueJsToggleButton2.default);

// Enable devtools
_vue2.default.config.devtools = true;
//2024/5/24
_vue2.default.config.silent = true;

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

var nprogress = new _vueNprogress2.default({ parent: '.nprogress-container' });

// const { state } = store
//
// router.beforeEach((route, redirect, next) => {
//   if (state.app.device.isMobile && state.app.sidebar.opened) {
//     store.commit(TOGGLE_SIDEBAR, false)
//   }
//   /* route.auth && (route.router.app.$store.state.token === 'null') */
//   if (state.app.authenticated === false && route.name !== 'Login') {
//     next({
//       path: '/login',
//       query: { redirect: route.fullPath }
//     })
//   } else {
//     next()
//   }
// })

(0, _keys2.default)(filters).forEach(function (key) {
  _vue2.default.filter(key, filters[key]);
});

var app = new _vue2.default((0, _extends3.default)({
  router: _router2.default,
  store: _store2.default,
  nprogress: nprogress
}, _App2.default));

exports.app = app;
exports.router = _router2.default;
exports.store = _store2.default;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(33);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = __webpack_require__(15);

function Timesheet(raw) {
    Timesheet.prototype.init.call(this, raw);
}

$.extend(Timesheet.prototype, {
    timesheet_id: null,
    employee_id: null,
    working_date: null,
    start_working_time: null,
    end_working_time: null,
    real_lunch_time: null,
    working_out: null,
    furikyu_taisho: null,
    note: null,
    init: function init(raw) {
        var self = this;

        self.timesheet_id = raw && raw.timesheet_id ? raw.timesheet_id : null;
        self.employee_id = raw && raw.employee_id ? raw.employee_id : null;
        self.working_date = raw && raw.working_date ? raw.working_date : null;
        self.start_working_time = raw && raw.start_working_time ? raw.start_working_time : null;
        self.end_working_time = raw && raw.end_working_time ? raw.end_working_time : null;
        self.real_lunch_time = raw && raw.real_lunch_time ? raw.real_lunch_time : null;
        self.working_out = raw && raw.working_out ? raw.working_out : null;
        self.furikyu_taisho = raw && raw.furikyu_taisho ? raw.furikyu_taisho : null;
        self.note = raw && raw.note ? raw.note : null;
    }

});

module.exports = Timesheet;

function TimesheetList(raw) {
    TimesheetList.prototype.init.call(this, raw);
}

$.extend(TimesheetList.prototype, {
    items: null,

    init: function init(raw) {
        var self = this;

        var items = [];

        if (raw) {
            for (var i = 0; i < (0, _keys2.default)(raw).length; i++) {
                items.push(raw[(0, _keys2.default)(raw)[i]]);
            }
        }

        self.items = items;
    },

    update: function update(raw) {
        var self = this;

        var items = [];

        for (var i = 0; i < (0, _keys2.default)(raw).length; i++) {
            items.push(raw[(0, _keys2.default)(raw)[i]]);
        }

        self.items = items;
    }
});

module.exports = TimesheetList;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TextFormat = {
  install: function install(Vue) {
    Vue.prototype.$textFormat = {
      rawText: function rawText(value) {
        var el = document.createElement('div');
        el.innerText = value;
        return el.innerHTML;
      }
    };
  }
};
exports.default = TextFormat;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowanceSwitch = exports.storeDateTimeTimesheetList = exports.storeDateTimeTotalOT = exports.storeDateTimeOTStatus = exports.storeDateTimeTimesheet = exports.switchEffect = exports.expandMenu = exports.toggleDevice = exports.toggleSidebar = exports.doAuthentication = undefined;

var _mutationTypes = __webpack_require__(16);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var doAuthentication = exports.doAuthentication = function doAuthentication(_ref, success) {
  var commit = _ref.commit;
  return commit(types.AUTHENTICATED, success);
};

var toggleSidebar = exports.toggleSidebar = function toggleSidebar(_ref2, opened) {
  var commit = _ref2.commit;
  return commit(types.TOGGLE_SIDEBAR, opened);
};

var toggleDevice = exports.toggleDevice = function toggleDevice(_ref3, device) {
  var commit = _ref3.commit;
  return commit(types.TOGGLE_DEVICE, device);
};

var expandMenu = exports.expandMenu = function expandMenu(_ref4, menuItem) {
  var commit = _ref4.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(types.EXPAND_MENU, menuItem);
  }
};

var switchEffect = exports.switchEffect = function switchEffect(_ref5, effectItem) {
  var commit = _ref5.commit;

  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem);
  }
};
var storeDateTimeTimesheet = exports.storeDateTimeTimesheet = function storeDateTimeTimesheet(_ref6, datetime) {
  var commit = _ref6.commit;

  commit(types.DATETIME_TIMESHEET, datetime);
};

var storeDateTimeOTStatus = exports.storeDateTimeOTStatus = function storeDateTimeOTStatus(_ref7, datetime) {
  var commit = _ref7.commit;
  return commit(types.DATETIME_OTSTATUS, datetime);
};

var storeDateTimeTotalOT = exports.storeDateTimeTotalOT = function storeDateTimeTotalOT(_ref8, datetime) {
  var commit = _ref8.commit;
  return commit(types.DATETIME_TOTALOT, datetime);
};

var storeDateTimeTimesheetList = exports.storeDateTimeTimesheetList = function storeDateTimeTimesheetList(_ref9, datetime) {
  var commit = _ref9.commit;
  return commit(types.DATETIME_TIMESHEETLIST, datetime);
};

var allowanceSwitch = exports.allowanceSwitch = function allowanceSwitch(_ref10, value) {
  var commit = _ref10.commit;
  return commit(types.ALLOWANCE_SWITCH, value);
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(16);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  authenticated: false,
  timesheetPage: false,
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  },
  eventCount: 0,
  timesheetStatus: {},
  datetimemytimesheet: null,
  datetimeotstatus: null,
  datetimetotalot: null,
  datetimetimesheetlist: null,
  allowanceSwitch: "family"
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.AUTHENTICATED, function (state, success) {
  state.authenticated = success;
}), (0, _defineProperty3.default)(_mutations, types.TIMESHEET_PAGE, function (state, success) {
  state.timesheetPage = success;
}), (0, _defineProperty3.default)(_mutations, types.TOGGLE_DEVICE, function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), (0, _defineProperty3.default)(_mutations, types.TOGGLE_SIDEBAR, function (state, opened) {
  if (state.device.isMobile) {
    state.sidebar.opened = opened;
  } else {
    state.sidebar.opened = true;
  }
}), (0, _defineProperty3.default)(_mutations, types.SWITCH_EFFECT, function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), (0, _defineProperty3.default)(_mutations, types.EVENT_COUNT, function (state) {
  state.eventCount++;
}), (0, _defineProperty3.default)(_mutations, types.TIMESHEET_STATUS, function (state, timesheet) {
  state.timesheetStatus = timesheet;
}), (0, _defineProperty3.default)(_mutations, types.DATETIME_TIMESHEET, function (state, datetime) {
  state.datetimemytimesheet = datetime;
}), (0, _defineProperty3.default)(_mutations, types.DATETIME_OTSTATUS, function (state, datetime) {
  state.datetimeotstatus = datetime;
}), (0, _defineProperty3.default)(_mutations, types.DATETIME_TOTALOT, function (state, datetime) {
  state.datetimetotalot = datetime;
}), (0, _defineProperty3.default)(_mutations, types.DATETIME_TIMESHEETLIST, function (state, datetime) {
  state.datetimetimesheetlist = datetime;
}), (0, _defineProperty3.default)(_mutations, types.ALLOWANCE_SWITCH, function (state, value) {
  state.allowanceSwitch = value;
}), _mutations);

exports.default = {
  state: state,
  mutations: mutations
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Allowance',
  meta: {
    icon: 'fa-gift',
    expanded: false,
    roles: [_globalservice2.default.ROLE.ADMIN]
  },

  children: [{
    name: 'View List',
    path: '/allowance/AllowanceViewList',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('allowance/AllowanceViewList')
  }, {
    name: 'Add New',
    path: '/allowance/AllowanceAddNew',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('allowance/AllowanceAddNew')
  }, {
    name: 'View Draft',
    path: '/allowance/AllowanceViewDraft',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('allowance/AllowanceViewDraft')
  }, {
    name: 'Setting',
    path: '/allowance/AllowanceSetting',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('allowance/AllowanceSetting')
  }]
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Budget',
  meta: {
    icon: 'fa-money',
    expanded: false,
    roles: _globalservice2.default.ALL_ROLE
  },

  children: [{
    name: 'Create Request',
    meta: {
      label: 'Create Request',
      roles: _globalservice2.default.ALL_ROLE
    },
    path: '/Budget/request',
    component: (0, _lazyLoading2.default)('Budget/CreateRequest')
  }, {
    name: 'Budget Request',
    path: '/Budget/MyRequest/',
    meta: {
      label: 'Budget Request',
      roles: _globalservice2.default.ALL_ROLE,
      link: '/Budget/MyRequest/'
    },
    component: (0, _lazyLoading2.default)('Budget/MyRequest')
  }, {
    name: 'Summary',
    meta: {
      label: 'Budget Summary',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    path: '/Budget/summary',
    component: (0, _lazyLoading2.default)('Budget/Summary')
  }, {
    name: 'All Request',
    meta: {
      label: 'All Request',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    path: '/Budget/allRequest',
    component: (0, _lazyLoading2.default)('Budget/AllRequest')
  }]
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Change Password',
  meta: {
    icon: 'fa-key',
    expanded: false,
    roles: _globalservice2.default.ALL_ROLE
  },
  path: '/changePassword',
  component: (0, _lazyLoading2.default)('user/ChangePassword')
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Holiday',
  meta: {
    icon: 'fa-clock-o',
    expanded: false,
    roles: _globalservice2.default.ALL_ROLE
  },

  children: [{
    name: 'Create Request',
    meta: {
      label: 'Create Request',
      roles: _globalservice2.default.ALL_ROLE
    },
    path: '/dayOff/request',
    component: (0, _lazyLoading2.default)('dayOff/RequestDayOff')
  }, {
    name: 'My Request',
    path: '/dayOff/myRequest/:id',
    meta: {
      label: 'My Request',
      roles: _globalservice2.default.ALL_ROLE,
      link: '/dayOff/myRequest/'
    },
    component: (0, _lazyLoading2.default)('dayOff/MyRequest')
  }, {
    name: 'Holiday Summary',
    meta: {
      label: 'Holiday Summary',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    path: '/dayOff/summary',
    component: (0, _lazyLoading2.default)('dayOff/Summary')
  }, {
    name: 'All Request',
    meta: {
      label: 'All Request',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    path: '/dayOff/allRequest',
    component: (0, _lazyLoading2.default)('dayOff/AllRequest')
  }, {
    name: 'Manager Request',
    meta: {
      label: 'Manager Request',
      roles: [_globalservice2.default.ROLE.GROUPMANAGER, _globalservice2.default.ROLE.ADMIN]
    },
    path: '/dayOff/managerRequest',
    component: (0, _lazyLoading2.default)('dayOff/ManagerRequest')
  }]
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'General',
  meta: {
    icon: 'fa-tasks',
    expanded: false,
    roles: [_globalservice2.default.ROLE.ADMIN]
  },

  children: [{
    name: 'Skill',
    path: '/general/skill',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('general/Skill')
  }, {
    name: 'Certificate',
    path: '/general/certificate',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('general/Certificate')
  }]
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Mail',
  meta: {
    icon: 'fa-envelope',
    expanded: false,
    roles: [_globalservice2.default.ROLE.ADMIN]
  },

  children: [{
    name: 'Send Mail',
    meta: {
      label: 'Send Mail',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    path: '/mail',
    component: (0, _lazyLoading2.default)('mailPayment/MailPayment')
  }, {
    name: 'Mail Template',
    path: '/mailTemplate',
    meta: {
      label: 'Mail Template',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('mailPayment/MailTemplate')
  }, {
    name: 'Mail Status',
    path: '/mailStatus',
    meta: {
      label: 'Mail Status',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('mailPayment/MailStatus')
  }]
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'News',
  meta: {
    icon: 'fa-newspaper-o',
    expanded: false,
    roles: [_globalservice2.default.ROLE.ADMIN]
  },
  path: '/news',
  component: (0, _lazyLoading2.default)('news/AllNews')
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Payslip',
  meta: {
    icon: 'fa fa-bank',
    expanded: false,
    roles: _globalservice2.default.ALL_ROLE
  },

  children: [{
    name: 'Upload Payslip',
    path: '/payslip/PayslipUpload',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('payslip/PayslipUpload')
  }, {
    name: 'Payslip Manager',
    path: '/payslip/PayslipManager',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('payslip/PayslipManager')
  }, {
    name: 'My Payslip',
    path: '/payslip/MyPayslip',
    meta: {
      roles: _globalservice2.default.ALL_ROLE
    },
    component: (0, _lazyLoading2.default)('payslip/MyPayslip')
  }]
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Team',
  meta: {
    icon: 'fa-space-shuttle',
    expanded: false,
    roles: _globalservice2.default.ALL_ROLE
  },
  path: '/allTeam',
  component: (0, _lazyLoading2.default)('team/AllTeam')
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Timesheet',
  meta: {
    icon: 'fa-calendar',
    expanded: false,
    roles: _globalservice2.default.ALL_ROLE
  },

  children: [{
    name: 'My Timesheet',
    path: '/timesheet/new/:id',
    meta: {
      label: 'My Timesheet',
      roles: _globalservice2.default.ALL_ROLE,
      link: '/timesheet/new/'
    },
    component: (0, _lazyLoading2.default)('timesheet/Newtimesheet')
  }, {
    name: 'OT Request',
    path: '/timesheet/OT-request/:id',
    meta: {
      label: 'OT Status',
      roles: _globalservice2.default.ALL_ROLE,
      link: '/timesheet/OT-request/'
    },
    component: (0, _lazyLoading2.default)('timesheet/OTRequest')
  }, {
    name: 'Total OT',
    path: '/timesheet/OT-total',
    meta: {
      label: 'Total OT',
      roles: [_globalservice2.default.ROLE.ADMIN, _globalservice2.default.ROLE.ACCOUNTANT, _globalservice2.default.ROLE.GROUPMANAGER, _globalservice2.default.ROLE.IINCHO]
    },
    component: (0, _lazyLoading2.default)('timesheet/OTTotal')
  }, {
    name: 'Absence List',
    path: '/timesheet/AbsenceList',
    meta: {
      label: 'Absence List',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('timesheet/AbsenceList')
  }, {
    name: 'Timesheet List',
    path: '/timesheet/TimesheetList',
    meta: {
      label: 'Timesheet List',
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    component: (0, _lazyLoading2.default)('timesheet/TimesheetList')
  }, {
    name: 'OT Manager Request',
    meta: {
      label: 'OT Manager Request',
      roles: [_globalservice2.default.ROLE.GROUPMANAGER, _globalservice2.default.ROLE.ADMIN]
    },
    path: '/timesheet/OTManagerRequest',
    component: (0, _lazyLoading2.default)('timesheet/OTManagerRequest')
  }]
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lazyLoading = __webpack_require__(5);

var _lazyLoading2 = _interopRequireDefault(_lazyLoading);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Member',
  meta: {
    icon: 'fa-user',
    expanded: false,
    roles: _globalservice2.default.ALL_ROLE
  },
  children: [{
    name: 'VTI Member',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN, _globalservice2.default.ROLE.TEAMLEAD, _globalservice2.default.ROLE.GROUPMANAGER, _globalservice2.default.ROLE.ACCOUNTANT]
    },
    path: '/user/all',
    component: (0, _lazyLoading2.default)('user/UserList')
  }, {
    name: 'Add New Member',
    meta: {
      roles: [_globalservice2.default.ROLE.ADMIN]
    },
    path: '/user/createUser',
    component: (0, _lazyLoading2.default)('user/CreateNewUser')
  }, {
    name: 'User Profile',
    meta: {
      label: 'My Profile',
      roles: _globalservice2.default.ALL_ROLE,
      link: '/user/userDetail/id/'
    },
    path: '/user/userDetail/id/:id',
    component: (0, _lazyLoading2.default)('user/UserDetail')
  }, {
    name: 'All User Request',
    meta: {
      label: 'All Request',
      roles: [_globalservice2.default.ROLE.ADMIN],
      link: '/user/allRequest/'
    },
    path: '/user/allRequest/:id',
    component: (0, _lazyLoading2.default)('user/AllRequest')
  }]
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _NprogressContainer = __webpack_require__(354);

var _NprogressContainer2 = _interopRequireDefault(_NprogressContainer);

var _layout = __webpack_require__(63);

var _vuex = __webpack_require__(3);

var _authenticationservice = __webpack_require__(9);

var _authenticationservice2 = _interopRequireDefault(_authenticationservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Navbar: _layout.Navbar,
    Sidebar: _layout.Sidebar,
    AppMain: _layout.AppMain,
    FooterBar: _layout.FooterBar,
    NprogressContainer: _NprogressContainer2.default
  },

  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar(!isMobile);
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: (0, _vuex.mapGetters)({
    sidebar: 'sidebar',
    authenticated: 'authenticated',
    timesheetPage: 'timesheetPage',
    allowanceSwitch: 'allowanceSwitch'
  }),

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleDevice', 'toggleSidebar']), {

    logout: function logout() {
      _authenticationservice2.default.logout();
    }
  })
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Levelbar = __webpack_require__(193);

var _Levelbar2 = _interopRequireDefault(_Levelbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Levelbar: _Levelbar2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _jquery = __webpack_require__(15);

var _jquery2 = _interopRequireDefault(_jquery);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return this.$store.state.pkg;
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    timesheet: 'timesheetStatus'
  }), {
    timesheetStatus: function timesheetStatus() {
      return this.timesheet ? this.timesheet : { status: null };
    },
    statusList: function statusList() {
      return {
        notSubmit: null,
        approved: 1,
        reject: 2,
        pending: 0
      };
    },
    myTimesheetPage: function myTimesheetPage() {
      return this.$route.name === 'My Timesheet';
    },
    previewTimesheetPage: function previewTimesheetPage() {
      return this.$route.name === 'Preview Timesheet';
    },
    isAdmin: function isAdmin() {
      var userProfile = JSON.parse(window.localStorage.getItem('user_profile'));
      return userProfile.user_role.role_id === _globalservice2.default.ROLE.ADMIN;
    },
    isMyTimesheet: function isMyTimesheet() {
      var userProfile = JSON.parse(window.localStorage.getItem('user_profile'));
      return userProfile.id === Number(this.$route.params.id);
    }
  }),
  methods: {
    saveTimesheet: function saveTimesheet() {
      (0, _jquery2.default)('body').trigger('timesheet');
    },

    toPreview: function toPreview() {
      (0, _jquery2.default)('body').trigger('preview');
    },

    toCheckin: function toCheckin() {
      (0, _jquery2.default)('body').trigger('checkin');
    },

    toCheckout: function toCheckout() {
      (0, _jquery2.default)('body').trigger('checkout');
    },

    submitTimesheet: function submitTimesheet() {
      this.$events.fire('submit-timesheet');
    },

    approveTimesheet: function approveTimesheet() {
      this.$events.fire('approve-timesheet');
    },

    rejectTimesheet: function rejectTimesheet() {
      this.$events.fire('reject-timesheet');
    }
  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaBreadcrumb = __webpack_require__(349);

var _vueBulmaBreadcrumb2 = _interopRequireDefault(_vueBulmaBreadcrumb);

var _vueBulmaTooltip = __webpack_require__(50);

var _vueBulmaTooltip2 = _interopRequireDefault(_vueBulmaTooltip);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Breadcrumb: _vueBulmaBreadcrumb2.default,
    Tooltip: _vueBulmaTooltip2.default
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    showing: "allowanceSwitch"
  }), {
    name: function name() {
      var allowanceTitile = [['Family Allowance List', 'Position Allowance List'], ['Add Family Allowance', 'Add Position Allowance'], ['Draft Family Allowance List', 'Draft Position Allowance List'], ['Family Allowance Setting', 'Position Allowance Setting']];
      if (this.$route.path.includes('allowance')) {
        if (this.$route.name === 'View List' && this.showing === 'family') {
          return allowanceTitile[0][0];
        } else if (this.$route.name === 'View List' && this.showing === 'position') {
          return allowanceTitile[0][1];
        } else if (this.$route.name === 'Add New' && this.showing === 'family') {
          return allowanceTitile[1][0];
        } else if (this.$route.name === 'Add New' && this.showing === 'position') {
          return allowanceTitile[1][1];
        } else if (this.$route.name === 'View Draft' && this.showing === 'family') {
          return allowanceTitile[2][0];
        } else if (this.$route.name === 'View Draft' && this.showing === 'position') {
          return allowanceTitile[2][1];
        } else if (this.$route.name === 'Setting' && this.showing === 'family') {
          return allowanceTitile[3][0];
        } else if (this.$route.name === 'Setting' && this.showing === 'position') {
          return allowanceTitile[3][1];
        }
      }
      return this.$route.name;
    }
  }),

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaTooltip = __webpack_require__(50);

var _vueBulmaTooltip2 = _interopRequireDefault(_vueBulmaTooltip);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

  components: {
    Tooltip: _vueBulmaTooltip2.default
  },

  props: {
    show: Boolean
  },

  computed: (0, _vuex.mapGetters)({
    pkginfo: 'pkg',
    sidebar: 'sidebar'
  }),

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleSidebar']), {
    logout: function logout() {
      this.$emit('logout');
    }
  })
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaExpanding = __webpack_require__(350);

var _vueBulmaExpanding2 = _interopRequireDefault(_vueBulmaExpanding);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Expanding: _vueBulmaExpanding2.default
  },

  props: {
    show: Boolean,
    role: Number,
    userId: Number
  },

  data: function data() {
    return {
      isReady: false
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: (0, _vuex.mapGetters)({
    menu: 'menuitems'
  }),

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['expandMenu', 'storeDateTimeTimesheet', 'storeDateTimeOTStatus', 'storeDateTimeTotalOT', 'storeDateTimeTimesheetList']), {
    resetDateTime: function resetDateTime(subItem) {
      if (subItem.name === 'My Timesheet') {
        this.storeDateTimeTimesheet(null);
        this.$events.fire('resetDateTimeTimeSheet');
      } else if (subItem.name === 'OT Request') {
        this.storeDateTimeOTStatus(null);
        this.$events.fire('resetDateTimeOTStatus');
      } else if (subItem.name === 'Total OT') {
        this.storeDateTimeTotalOT(null);
      } else if (subItem.name === 'Timesheet List') {
        this.storeDateTimeTimesheetList(null);
      }
    },
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      if (subItem.name === 'User Profile' || subItem.name === 'OT Request' || subItem.name === 'My Timesheet' || subItem.name === 'My Request' || subItem.name === 'All User Request') {
        return '' + (item.component ? item.path + '/' : '') + (subItem.meta.link + this.userId);
      }
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _timesheetservice = __webpack_require__(215);

var _timesheetservice2 = _interopRequireDefault(_timesheetservice);

var _ultilities = __webpack_require__(211);

var _ultilities2 = _interopRequireDefault(_ultilities);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(36);

var _index2 = _interopRequireDefault(_index);

var _mutationTypes = __webpack_require__(16);

var _LoadModal = __webpack_require__(21);

var _LoadModal2 = _interopRequireDefault(_LoadModal);

var _AlertModal = __webpack_require__(23);

var _AlertModal2 = _interopRequireDefault(_AlertModal);

var _NoteModal = __webpack_require__(196);

var _NoteModal2 = _interopRequireDefault(_NoteModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    moment: _moment2.default
  },
  data: function data() {
    return {
      previewData: null,
      error: null,
      substituteTxt: '休出',
      halfDayOffTxt: '半休',
      absenceTxt: '欠勤',
      holidayTxt: '休日',
      substituteDayOffTxt: '振休',
      holidayWorkOT: 'OT精算',
      holidayWorkSubstitute: '代休',
      headers: [],
      dayOffType: _globalservice2.default.DAY_OFF_TYPE,
      allDayType: null,
      total: {},
      dayInMonth: 0,
      user: {},
      currentMonth: null,
      timesheetData: {},
      openLoadModal: null,
      openAlertModal: null,
      noteModal: null
    };
  },
  created: function created() {
    var self = this;
    self.getPreviewTimesheet();
    self.getTimesheetStatus();
  },
  mounted: function mounted() {
    _index2.default.commit(_mutationTypes.TIMESHEET_PAGE, true);
    var self = this;
    this.$events.listen('submit-timesheet', self.submitTimesheet);
    this.$events.listen('approve-timesheet', self.approveTimesheet);
    this.$events.listen('reject-timesheet', self.showNoteModal);
    this.$events.listen('complete-message', function (message) {
      return self.rejectTimesheet(message);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$events.remove('submit-timesheet');
    this.$events.remove('approve-timesheet');
    this.$events.remove('reject-timesheet');
    this.$events.remove('complete-message');
    _index2.default.commit(_mutationTypes.TIMESHEET_PAGE, false);
    _index2.default.commit(_mutationTypes.TIMESHEET_STATUS, null);
  },


  computed: {
    sumSubstitute: function sumSubstitute() {
      var totalSubstitute = 0;
      for (var i = 1; i <= this.dayInMonth; i++) {
        if (!this.empty(this.previewData[i].type) && this.previewData[i].type === this.dayOffType.SUBSTITUTE) {
          this.isHalfWorking(this.previewData[i]) ? totalSubstitute += 0.5 : totalSubstitute += 1;
        }
      }
      return totalSubstitute;
    },
    sumAllowedDayOff: function sumAllowedDayOff() {
      var totalDayOff = 0;
      for (var i = 1; i <= this.dayInMonth; i++) {
        if (!this.empty(this.previewData[i].working_out) && (this.previewData[i].type === this.dayOffType.ALLOWED || this.previewData[i].type === this.dayOffType.LAST_YEAR)) {
          this.isHalfWorking(this.previewData[i]) ? totalDayOff += 0.5 : totalDayOff += 1;
        }
      }
      return totalDayOff;
    },
    sumNotAllowedDayOff: function sumNotAllowedDayOff() {
      var totalMukyu = 0;
      for (var i = 1; i <= this.dayInMonth; i++) {
        if (this.empty(this.previewData[i].working_out) || !this.empty(this.previewData[i].is_off_work)) {
          continue;
        }
        if (this.previewData[i].type === this.dayOffType.NOT_ALLOWED) {
          totalMukyu += 1;
        } else if (this.previewData[i].type === this.dayOffType.HALF_DAY) {
          totalMukyu += 0.5;
        }
      }
      return totalMukyu;
    },
    userFullName: function userFullName() {
      return !this.user.first_name || !this.user.last_name ? '' : this.user.first_name + ' ' + this.user.last_name;
    }
  },

  methods: {
    getPreviewTimesheet: function getPreviewTimesheet() {
      var self = this;
      _timesheetservice2.default.getPreviewTimesheet(self.$route.params.id, self.$route.params.month, self.$route.params.year, function (response) {
        if (response.status === 'success') {
          self.previewData = response.data.data;
          self.headers = response.data.header;
          self.allDayType = response.data.allDayType;
          self.total = response.data.total;
          self.dayInMonth = response.data.dayInMonth;
          self.user = response.data.user;
          self.currentMonth = response.data.currentMonth;
        } else {
          console.log(response);
        }
      }, function (err) {
        self.error = err;
      });
    },
    getTimesheetStatus: function getTimesheetStatus() {
      var self = this;
      var timesheet = {
        user_id: self.$route.params.id,
        month: self.$route.params.month,
        year: self.$route.params.year
      };
      _timesheetservice2.default.getTimesheetStatusOfUser(timesheet, function (response) {
        if (response.status === 'success') {
          self.timesheetData = response.data;
          _index2.default.commit(_mutationTypes.TIMESHEET_STATUS, response ? response.data : null);
        }
      }, function (err) {
        _index2.default.commit(_mutationTypes.TIMESHEET_STATUS, err);
        self.error = err.message;
      });
    },
    submitTimesheet: function submitTimesheet() {
      var self = this;
      var timesheet = {
        user_id: self.$route.params.id,
        month: self.$route.params.month,
        year: self.$route.params.year
      };
      this.showLoad();
      this.showModal = false;
      _timesheetservice2.default.submitTimesheet(timesheet, function () {
        self.hideLoad();
        self.showAlertModal('Submit timesheet successfully.', true);
      }, function (err) {
        self.hideLoad();
        self.showAlertModal(err.message);
      });
    },
    approveTimesheet: function approveTimesheet() {
      var self = this;
      var timesheet = {
        user_id: self.$route.params.id,
        month: self.$route.params.month,
        year: self.$route.params.year
      };
      this.showLoad();
      this.showModal = false;
      _timesheetservice2.default.approveTimesheet(timesheet, function () {
        self.hideLoad();
        // Reload the page directly on success
        window.location.reload();
      }, function (err) {
        self.hideLoad();
        // Show the alert modal on error
        self.showAlertModal(err.message);
      });
    },
    rejectTimesheet: function rejectTimesheet(message) {
      var self = this;
      var timesheet = {
        user_id: self.$route.params.id,
        month: self.$route.params.month,
        year: self.$route.params.year,
        note: message
      };
      this.showLoad();
      this.showModal = false;
      _timesheetservice2.default.rejectTimesheet(timesheet, function () {
        self.hideLoad();
        self.showAlertModal('Reject timesheet successfully.', true);
      }, function (err) {
        self.hideLoad();
        self.showAlertModal(err.message);
      });
    },
    statusToLabel: function statusToLabel(value) {
      return value === null ? '<span class="tag is-info is-small" style="font-size:12px"><span class="icon is-small"><i class="fa fa-eye-slash fa-1"></i></span>&nbsp; 未提出</span>' : value === 1 ? '<span class="tag is-primary is-small" style="font-size:12px"><span class="icon is-small"><i class="fa fa-check fa-1"></i></span>&nbsp; 承認済み</span>' : value === 2 ? '<span class="tag is-danger is-small" style="font-size:12px"><span class="icon is-small"><i class="fa fa-ban fa-1"></i></span>&nbsp; Rejected</span>' : '<span class="tag is-warning is-small" style="font-size:12px"><span class="icon is-small"><i class="fa fa-spinner fa-pulse fa-1"></i></span>&nbsp; 承認待ち</span>';
    },
    isHalfWorking: function isHalfWorking(value) {
      return !this.empty(value.working_out) && value.is_off_day === 1 && value.time_off !== _globalservice2.default.DAY_OFF_TIME.ALL_DAY.id;
    },
    isWorking: function isWorking(value) {
      return !this.empty(value.working_out) && (value.type === _globalservice2.default.DAY_OFF_TYPE.WORKING || value.type === _globalservice2.default.DAY_OFF_TYPE.HALF_DAY || this.isHalfWorking(value));
    },
    empty: function empty(value) {
      return _ultilities2.default.empty(value);
    },
    weekDay: function weekDay(date) {
      var day = (0, _moment2.default)(date);
      return day.weekday();
    },
    offWork: function offWork(value) {
      return !this.empty(value.is_off_day) || !this.empty(value.is_substitute_dayoff) || !this.empty(value.is_off_work) || this.isHalfWorking(value) || value.type === this.dayOffType.HALF_DAY;
    },
    weekendAndHoliday: function weekendAndHoliday(value) {
      return !this.empty(value.is_off_work);
    },
    holidayOff: function holidayOff(value) {
      return !this.empty(value.is_holiday) && this.empty(value.ot_time_start);
    },
    backHistory: function backHistory() {
      window.history.back();
    },
    showLoad: function showLoad() {
      var LoadModalComponent = _vue2.default.extend(_LoadModal2.default);
      var propsData = {
        visible: true
      };
      this.openLoadModal = new LoadModalComponent({
        el: document.createElement('div'),
        propsData: propsData
      });
    },
    hideLoad: function hideLoad() {
      this.openLoadModal.deactive();
    },
    showAlertModal: function showAlertModal(message) {
      var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var self = this;
      var AlertModalComponent = _vue2.default.extend(_AlertModal2.default);
      var propsData = {
        visible: true,
        message: message,
        title: 'Message',
        okText: 'OK',
        reload: reload,
        ok: function ok() {
          self.openAlertModal.$children[0].deactive();
        }
      };
      this.openAlertModal = new AlertModalComponent({
        el: document.createElement('div'),
        propsData: propsData
      });
    },
    showNoteModal: function showNoteModal() {
      var self = this;
      var NoteModalComponent = _vue2.default.extend(_NoteModal2.default);
      var propsData = {
        visible: true,
        title: "Admin's message",
        okText: 'OK',
        cancelText: 'Cancel',
        reload: false,
        cancel: function cancel() {
          self.openNoteModal.$children[0].deactive();
        }
      };
      this.openNoteModal = new NoteModalComponent({
        el: document.createElement('div'),
        propsData: propsData
      });
    }
  }
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = __webpack_require__(63);

var _vuex = __webpack_require__(3);

var _userservice = __webpack_require__(48);

var _userservice2 = _interopRequireDefault(_userservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Sidebar: _layout.Sidebar,
    Levelbar: _layout.Levelbar,
    FooterBar: _layout.FooterBar
  },

  data: function data() {
    return {
      role: 0,
      userId: null
    };
  },

  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar(!isMobile);
      }
    };

    var user = _userservice2.default.getUserProfile();
    this.role = user.role;
    this.userId = user.id;

    handler();
    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: (0, _vuex.mapGetters)({
    sidebar: 'sidebar'
  }),

  methods: (0, _vuex.mapActions)(['toggleDevice', 'toggleSidebar'])
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return this.$store.state.pkg;
  }
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBulmaModal = __webpack_require__(28);

exports.default = {
  components: {
    Modal: _vueBulmaModal.Modal
  },

  props: {
    visible: Boolean,
    title: String,
    message: String,
    okText: String,
    ok: Function,
    reload: false
  },

  methods: {
    close: function close() {
      this.$emit('close');
      if (this.reload) {
        window.location.reload();
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBulmaModal = __webpack_require__(28);

exports.default = {
  mixins: [_vueBulmaModal.BaseModal],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBulmaModal = __webpack_require__(28);

var _veeValidate = __webpack_require__(34);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_veeValidate2.default, _globalservice2.default.VALIDATE_CONFIG);

exports.default = {
  components: {
    Modal: _vueBulmaModal.Modal
  },

  props: {
    visible: Boolean,
    title: String,
    okText: String,
    cancelText: String,
    cancel: Function,
    reload: false,
    message: String
  },

  data: function data() {
    return {
      adminMessage: null
    };
  },


  methods: {
    close: function close() {
      this.$emit('close');
      if (this.reload) {
        window.location.reload();
      }
    },
    handleMessage: function handleMessage() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$events.fire('complete-message', _this.adminMessage);
          _this.cancel();
        }
      });
    }
  },

  watch: {
    message: function message() {
      this.adminMessage = this.message;
    }
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//


exports.default = {};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//


exports.default = {};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(3);

var _authenticationservice = __webpack_require__(9);

var _authenticationservice2 = _interopRequireDefault(_authenticationservice);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      user: {},
      error: '',
      currentPass: ''
    };
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['expandMenu', 'toggleDevice', 'toggleSidebar']), {
    confirmPass: function confirmPass() {
      var data = {};
      var self = this;
      data.password = this.currentPass;
      var url = this.getQueryParamByName("to");
      _authenticationservice2.default.confirmPassword(self, data, function () {
        window.localStorage.setItem('checkInAt', (0, _moment2.default)().format());
      }, '/payslip/' + url);
    },
    getQueryParamByName: function getQueryParamByName(name) {
      return this.$route.query[name];
    }
  })

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _authenticationservice = __webpack_require__(9);

var _authenticationservice2 = _interopRequireDefault(_authenticationservice);

var _AlertModal = __webpack_require__(23);

var _AlertModal2 = _interopRequireDefault(_AlertModal);

var _LoadModal = __webpack_require__(21);

var _LoadModal2 = _interopRequireDefault(_LoadModal);

var _veeValidate = __webpack_require__(34);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_veeValidate2.default, _globalservice2.default.VALIDATE_CONFIG);

exports.default = {
  data: function data() {
    return {
      email: '',
      error: '',
      message: null,
      disableButton: false,
      showModal: false,
      openLoadModal: null
    };
  },


  components: {
    alertModal: _AlertModal2.default
  },

  computed: {
    validation: function validation() {
      return {
        email: !!this.email.trim()
      };
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (_this.validation.email) {
            var credentials = {
              data: _this.email.trim()
            };
            var self = _this;
            _this.disableButton = true;
            self.showLoad();
            _authenticationservice2.default.sendMailForgotPassword(_this, credentials, function (response) {
              self.hideLoad();
              self.error = response.status === 'fail' ? response.message : null;
              if (response.status === 'success') {
                self.message = 'Email sent successfully. Please check your mailbox.';
                self.showModal = true;
              }
              self.disableButton = false;
            });
          }
        }
      });
    },


    closeModalBasic: function closeModalBasic() {
      this.showModal = false;
    },

    showLoad: function showLoad() {
      var LoadModalComponent = _vue2.default.extend(_LoadModal2.default);
      var propsData = {
        visible: true
      };
      this.openLoadModal = new LoadModalComponent({
        el: document.createElement('div'),
        propsData: propsData
      });
    },
    hideLoad: function hideLoad() {
      this.openLoadModal.deactive();
    }
  }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _authenticationservice = __webpack_require__(9);

var _authenticationservice2 = _interopRequireDefault(_authenticationservice);

var _AlertModal = __webpack_require__(23);

var _AlertModal2 = _interopRequireDefault(_AlertModal);

var _LoadModal = __webpack_require__(21);

var _LoadModal2 = _interopRequireDefault(_LoadModal);

var _veeValidate = __webpack_require__(34);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_veeValidate2.default, _globalservice2.default.VALIDATE_CONFIG);

exports.default = {
  data: function data() {
    return {
      password: '',
      confirmPassword: '',
      token: this.$route.params.token,
      error: '',
      tokenValid: 0,
      disableButton: false,
      showModal: false,
      message: null
    };
  },


  components: {
    alertModal: _AlertModal2.default
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (_this.password === _this.confirmPassword) {
            var data = {
              password: _this.password,
              token: _this.token
            };
            var self = _this;
            _this.disableButton = true;
            self.showLoad();
            _authenticationservice2.default.resetForgotPassword(_this, data, function (response) {
              self.hideLoad();
              self.error = response.status === 'fail' ? response.message : null;
              if (response.status === 'success') {
                self.showModal = true;
                self.message = 'Password changed successfully. Please login with the new password';
              }
              self.disableButton = false;
            });
          } else {
            _this.error = 'Password and Confirmation Password must match';
          }
        }
      });
    },


    closeModalBasic: function closeModalBasic() {
      var self = this;
      self.showModal = false;
      setTimeout(function () {
        self.$router.push('/login');
      }, 500);
    },

    showLoad: function showLoad() {
      var LoadModalComponent = _vue2.default.extend(_LoadModal2.default);
      var propsData = {
        visible: true
      };
      this.openLoadModal = new LoadModalComponent({
        el: document.createElement('div'),
        propsData: propsData
      });
    },
    hideLoad: function hideLoad() {
      this.openLoadModal.deactive();
    }
  },

  created: function created() {
    var self = this;
    _authenticationservice2.default.verifyForgotPasswordRequest(this, this.token, function (response) {
      self.tokenValid = response.status === 'success' ? 1 : 2;
    });
  }
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(3);

var _authenticationservice = __webpack_require__(9);

var _authenticationservice2 = _interopRequireDefault(_authenticationservice);

var _globalservice = __webpack_require__(2);

var _globalservice2 = _interopRequireDefault(_globalservice);

var _vue = __webpack_require__(6);

var _vue2 = _interopRequireDefault(_vue);

var _vueGoogleSigninButton = __webpack_require__(341);

var _vueGoogleSigninButton2 = _interopRequireDefault(_vueGoogleSigninButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueGoogleSigninButton2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      email: '',
      password: '',
      error: '',
      googleSignInParams: {
        client_id: _globalservice2.default.GOOGLE_CLIENT_ID,
        prompt: 'select_account'
      }
    };
  },


  // computed property for form validation state
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    authenticated: 'authenticated'
  }), {
    validation: function validation() {
      return {
        email: !!this.email.trim(),
        password: !!this.password.trim()
      };
    }
  }),

  // methods
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['doAuthentication']), {
    onSubmit: function onSubmit() {
      this.error = '';
      if (this.validation.email && this.validation.password) {
        var credentials = {
          email: this.email.trim(),
          password: this.password.trim()
        };
        _authenticationservice2.default.login(this, credentials, 'Home');
      }
    },
    onSignInSuccess: function onSignInSuccess(googleUser) {
      this.error = '';
      var idToken = googleUser.getAuthResponse().id_token;
      _authenticationservice2.default.login(this, { 'token': idToken }, 'Home', true);
    },
    onSignInError: function onSignInError(error) {
      console.log('e', error);
    }
  })
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _PreviewTimesheet = __webpack_require__(348);

var _PreviewTimesheet2 = _interopRequireDefault(_PreviewTimesheet);

var _vuex = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//

exports.default = {
    components: {
        PreviewTimesheet: _PreviewTimesheet2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['eventcount']))
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(26);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    title: {
      type: String
    },
    okText: {
      type: String,
      default: 'Ok'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  },

  methods: {
    ok: function ok() {
      this.$emit('ok');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(26);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(26);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'nprogress-container'
};

/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 66,
	"./af.js": 66,
	"./ar": 73,
	"./ar-dz": 67,
	"./ar-dz.js": 67,
	"./ar-kw": 68,
	"./ar-kw.js": 68,
	"./ar-ly": 69,
	"./ar-ly.js": 69,
	"./ar-ma": 70,
	"./ar-ma.js": 70,
	"./ar-sa": 71,
	"./ar-sa.js": 71,
	"./ar-tn": 72,
	"./ar-tn.js": 72,
	"./ar.js": 73,
	"./az": 74,
	"./az.js": 74,
	"./be": 75,
	"./be.js": 75,
	"./bg": 76,
	"./bg.js": 76,
	"./bm": 77,
	"./bm.js": 77,
	"./bn": 78,
	"./bn.js": 78,
	"./bo": 79,
	"./bo.js": 79,
	"./br": 80,
	"./br.js": 80,
	"./bs": 81,
	"./bs.js": 81,
	"./ca": 82,
	"./ca.js": 82,
	"./cs": 83,
	"./cs.js": 83,
	"./cv": 84,
	"./cv.js": 84,
	"./cy": 85,
	"./cy.js": 85,
	"./da": 86,
	"./da.js": 86,
	"./de": 89,
	"./de-at": 87,
	"./de-at.js": 87,
	"./de-ch": 88,
	"./de-ch.js": 88,
	"./de.js": 89,
	"./dv": 90,
	"./dv.js": 90,
	"./el": 91,
	"./el.js": 91,
	"./en-SG": 92,
	"./en-SG.js": 92,
	"./en-au": 93,
	"./en-au.js": 93,
	"./en-ca": 94,
	"./en-ca.js": 94,
	"./en-gb": 95,
	"./en-gb.js": 95,
	"./en-ie": 96,
	"./en-ie.js": 96,
	"./en-il": 97,
	"./en-il.js": 97,
	"./en-nz": 98,
	"./en-nz.js": 98,
	"./eo": 99,
	"./eo.js": 99,
	"./es": 102,
	"./es-do": 100,
	"./es-do.js": 100,
	"./es-us": 101,
	"./es-us.js": 101,
	"./es.js": 102,
	"./et": 103,
	"./et.js": 103,
	"./eu": 104,
	"./eu.js": 104,
	"./fa": 105,
	"./fa.js": 105,
	"./fi": 106,
	"./fi.js": 106,
	"./fo": 107,
	"./fo.js": 107,
	"./fr": 110,
	"./fr-ca": 108,
	"./fr-ca.js": 108,
	"./fr-ch": 109,
	"./fr-ch.js": 109,
	"./fr.js": 110,
	"./fy": 111,
	"./fy.js": 111,
	"./ga": 112,
	"./ga.js": 112,
	"./gd": 113,
	"./gd.js": 113,
	"./gl": 114,
	"./gl.js": 114,
	"./gom-latn": 115,
	"./gom-latn.js": 115,
	"./gu": 116,
	"./gu.js": 116,
	"./he": 117,
	"./he.js": 117,
	"./hi": 118,
	"./hi.js": 118,
	"./hr": 119,
	"./hr.js": 119,
	"./hu": 120,
	"./hu.js": 120,
	"./hy-am": 121,
	"./hy-am.js": 121,
	"./id": 122,
	"./id.js": 122,
	"./is": 123,
	"./is.js": 123,
	"./it": 125,
	"./it-ch": 124,
	"./it-ch.js": 124,
	"./it.js": 125,
	"./ja": 126,
	"./ja.js": 126,
	"./jv": 127,
	"./jv.js": 127,
	"./ka": 128,
	"./ka.js": 128,
	"./kk": 129,
	"./kk.js": 129,
	"./km": 130,
	"./km.js": 130,
	"./kn": 131,
	"./kn.js": 131,
	"./ko": 132,
	"./ko.js": 132,
	"./ku": 133,
	"./ku.js": 133,
	"./ky": 134,
	"./ky.js": 134,
	"./lb": 135,
	"./lb.js": 135,
	"./lo": 136,
	"./lo.js": 136,
	"./lt": 137,
	"./lt.js": 137,
	"./lv": 138,
	"./lv.js": 138,
	"./me": 139,
	"./me.js": 139,
	"./mi": 140,
	"./mi.js": 140,
	"./mk": 141,
	"./mk.js": 141,
	"./ml": 142,
	"./ml.js": 142,
	"./mn": 143,
	"./mn.js": 143,
	"./mr": 144,
	"./mr.js": 144,
	"./ms": 146,
	"./ms-my": 145,
	"./ms-my.js": 145,
	"./ms.js": 146,
	"./mt": 147,
	"./mt.js": 147,
	"./my": 148,
	"./my.js": 148,
	"./nb": 149,
	"./nb.js": 149,
	"./ne": 150,
	"./ne.js": 150,
	"./nl": 152,
	"./nl-be": 151,
	"./nl-be.js": 151,
	"./nl.js": 152,
	"./nn": 153,
	"./nn.js": 153,
	"./pa-in": 154,
	"./pa-in.js": 154,
	"./pl": 155,
	"./pl.js": 155,
	"./pt": 157,
	"./pt-br": 156,
	"./pt-br.js": 156,
	"./pt.js": 157,
	"./ro": 158,
	"./ro.js": 158,
	"./ru": 159,
	"./ru.js": 159,
	"./sd": 160,
	"./sd.js": 160,
	"./se": 161,
	"./se.js": 161,
	"./si": 162,
	"./si.js": 162,
	"./sk": 163,
	"./sk.js": 163,
	"./sl": 164,
	"./sl.js": 164,
	"./sq": 165,
	"./sq.js": 165,
	"./sr": 167,
	"./sr-cyrl": 166,
	"./sr-cyrl.js": 166,
	"./sr.js": 167,
	"./ss": 168,
	"./ss.js": 168,
	"./sv": 169,
	"./sv.js": 169,
	"./sw": 170,
	"./sw.js": 170,
	"./ta": 171,
	"./ta.js": 171,
	"./te": 172,
	"./te.js": 172,
	"./tet": 173,
	"./tet.js": 173,
	"./tg": 174,
	"./tg.js": 174,
	"./th": 175,
	"./th.js": 175,
	"./tl-ph": 176,
	"./tl-ph.js": 176,
	"./tlh": 177,
	"./tlh.js": 177,
	"./tr": 178,
	"./tr.js": 178,
	"./tzl": 179,
	"./tzl.js": 179,
	"./tzm": 181,
	"./tzm-latn": 180,
	"./tzm-latn.js": 180,
	"./tzm.js": 181,
	"./ug-cn": 182,
	"./ug-cn.js": 182,
	"./uk": 183,
	"./uk.js": 183,
	"./ur": 184,
	"./ur.js": 184,
	"./uz": 186,
	"./uz-latn": 185,
	"./uz-latn.js": 185,
	"./uz.js": 186,
	"./vi": 187,
	"./vi.js": 187,
	"./x-pseudo": 188,
	"./x-pseudo.js": 188,
	"./yo": 189,
	"./yo.js": 189,
	"./zh-cn": 190,
	"./zh-cn.js": 190,
	"./zh-hk": 191,
	"./zh-hk.js": 191,
	"./zh-tw": 192,
	"./zh-tw.js": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 336;

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(325)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(370),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(326)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(328)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(330)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(375),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  "data-v-0962c5a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(332)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(378),
  /* scopeId */
  "data-v-d1a8e0c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(364),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(356),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(365),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(366),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden,
      "role": _vm.role,
      "userId": _vm.userId
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor",
    attrs: {
      "droppable": "true"
    }
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPass),
      expression: "currentPass"
    }],
    staticClass: "input password",
    attrs: {
      "type": "password",
      "placeholder": "Enter your password"
    },
    domProps: {
      "value": (_vm.currentPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPass = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.confirmPass()
      }
    }
  }, [_vm._v("\n            Confirm\n          ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-label"
  }, [_c('h3', [_vm._v("Confirm your password to access this page")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")])])
}]}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error && _vm.error != ''),
      expression: "error && error != ''"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word",
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.userFullName.length) ? _c('article', {
    staticClass: "tile is-child box"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              氏名:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.userFullName))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              社員番号:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.user_code))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              入社日:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.start_from))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              採用形態:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.contract_type))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              Status:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.statusToLabel(_vm.timesheetData ? _vm.timesheetData.status : null))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              会社名:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.user.vti_group === 'VTI Japan' ? '株式会社VTIジャパン' : '株式会社VTIコーポレーション') + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              報告年月:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.currentMonth))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              所定労働時間:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.working_hour))])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              休憩時間:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.break_time_format))])])]), _vm._v(" "), (_vm.timesheetData) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_vm._v("\n              Admin's message:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(_vm._s(_vm.timesheetData.note))])])]) : _vm._e()])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "control is-pulled-left"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.backHistory
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Back")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered"
  }, [_c('thead', [_c('tr', _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      key: index
    }, [_vm._v("\n            " + _vm._s(header) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.previewData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      class: {
        'is-off-work': _vm.weekendAndHoliday(item)
      }
    }, [_vm._v(_vm._s(item.day_in_week))]), _vm._v(" "), _c('td', {
      class: {
        'is-off-work': _vm.offWork(item)
      }
    }, [((!_vm.empty(item.is_substitute_dayoff) || (item.is_off_work && !_vm.empty(item.ot_time_start))) && _vm.isWorking(item)) ? [_vm._v("\n              " + _vm._s(_vm.substituteTxt) + "\n            ")] : (!_vm.empty(item.type)) ? [(item.type === _vm.dayOffType.SUBSTITUTE) ? [_vm._v("\n                " + _vm._s(_vm.substituteDayOffTxt) + "\n              ")] : (item.type === _vm.dayOffType.HALF_DAY || _vm.isHalfWorking(item)) ? [_vm._v("\n                " + _vm._s(_vm.halfDayOffTxt) + "\n              ")] : (item.type === _vm.dayOffType.NOT_ALLOWED) ? [_vm._v("\n                " + _vm._s(_vm.absenceTxt) + "\n              ")] : ((!_vm.empty(item.is_off_work) || !_vm.empty(item.is_off_day)) && _vm.empty(item.ot_time_start)) ? [_vm._v("\n                " + _vm._s(_vm.holidayTxt) + "\n              ")] : _vm._e()] : (_vm.weekDay(item.date.date) === 0 || _vm.weekDay(item.date.date) === 6) ? [_vm._v("\n              " + _vm._s(_vm.holidayTxt) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.start_working_time) && _vm.isWorking(item) ? item.start_working_time : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.end_working_time) && _vm.isWorking(item) ? item.end_working_time : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.real_lunch_time) && _vm.isWorking(item) ? item.real_lunch_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', [(!_vm.empty(item.type) && item.type === _vm.dayOffType.SUBSTITUTE) ? [_vm._v("\n              " + _vm._s(_vm.isHalfWorking(item) ? 0.5 : 1) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', [(!_vm.empty(item.working_out) && (item.type === _vm.dayOffType.ALLOWED || item.type === _vm.dayOffType.LAST_YEAR)) ? [_vm._v("\n              " + _vm._s(_vm.isHalfWorking(item) ? 0.5 : 1) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.working_out) && _vm.isWorking(item) ? item.working_out : '') + "\n          ")]), _vm._v(" "), _c('td', [(!_vm.empty(item.working_out) && _vm.empty(item.is_off_work)) ? [(item.type === _vm.dayOffType.NOT_ALLOWED) ? [_vm._v("\n                " + _vm._s(1) + "\n              ")] : (item.type === _vm.dayOffType.HALF_DAY) ? [_vm._v("\n                " + _vm._s(0.5) + "\n              ")] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.over_time) && _vm.empty(item.is_off_work) ? item.over_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.over_night_time) && _vm.empty(item.is_off_work) ? item.over_night_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.over_time) && !_vm.empty(item.is_off_work) ? item.over_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(!_vm.empty(item.over_night_time) && !_vm.empty(item.is_off_work) ? item.over_night_time_string : '') + "\n          ")]), _vm._v(" "), _c('td', {
      class: {
        'is-off-work': _vm.holidayOff(item)
      }
    }, [(!_vm.empty(item.note)) ? [_vm._v("\n              " + _vm._s(item.note) + "\n            ")] : (item.is_substitute_dayoff !== null && !_vm.empty(item.is_off_work) && !_vm.empty(item.ot_time_start) && _vm.isWorking(item)) ? [(!_vm.empty(item.is_substitute_dayoff)) ? [_vm._v("\n                " + _vm._s(_vm.holidayWorkSubstitute) + "\n              ")] : [_vm._v("\n                " + _vm._s(_vm.holidayWorkOT) + "\n              ")]] : (!_vm.empty(item.type)) ? [(_vm.allDayType[item.type]['is_off_day']) ? [_vm._v("\n                " + _vm._s(_vm.allDayType[item.type]['type_name']) + "\n              ")] : (item.is_holiday) ? [_vm._v("\n                " + _vm._s(_vm.allDayType[_vm.dayOffType.JAPAN_HOLIDAY]['type_name']) + "\n              ")] : _vm._e()] : _vm._e()], 2)])
  }), _vm._v(" "), (_vm.previewData) ? _c('tr', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "italic"
    }
  }, [_c('td', {
    staticStyle: {
      "font-style": "normal"
    }
  }, [_vm._v("合計")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.break))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumSubstitute))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumAllowedDayOff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalWork))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sumNotAllowedDayOff))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalOT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalNightOT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalHolidayOT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total.totalHolidayNightOT))]), _vm._v(" "), _c('td')]) : _vm._e()], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
}]}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible,
      "title": _vm.title,
      "transition": "fade"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.adminMessage),
      expression: "adminMessage"
    }],
    class: {
      'textarea': true, 'is-danger': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": "Add a message"
    },
    domProps: {
      "value": (_vm.adminMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adminMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('message')))])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.handleMessage
    }
  }, [_vm._v(_vm._s(_vm.okText))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])])])])
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("You don't have permission to access this page")])])
}]}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Can't find your page")])])
}]}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('p', {
    staticClass: "image loading-gif"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(226)
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.deactive
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h2', {
    staticClass: "subtitle is-10 level-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "10px 0px"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "has-text-right"
  }, [_c('router-link', {
    attrs: {
      "to": '/forgotPassword'
    }
  }, [_vm._v("Forgot your password?")])], 1)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('g-signin-button', {
    attrs: {
      "params": _vm.googleSignInParams
    },
    on: {
      "success": _vm.onSignInSuccess,
      "error": _vm.onSignInError
    }
  }, [_c('span', {
    staticClass: "google-button__icon"
  }, [_c('i', {
    staticClass: "fa fa-google"
  })]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "google-text"
  }, [_vm._v(" Sign in with Google")])])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px",
      "width": "auto",
      "margin-top": "15px"
    },
    attrs: {
      "src": __webpack_require__(17),
      "alt": "Image1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-left"
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  Login\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" Remember me\n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary login-button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separator"
  }, [_c('span', {
    staticClass: "separator-text"
  }, [_vm._v("OR")])])
}]}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "column has-text-centered",
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.error) + "\n                "), _c('br')]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Enter your email address to reset your password.")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email')),
      expression: "errors.has('Email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Email')))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "has-text-right"
  }, [_c('router-link', {
    attrs: {
      "to": '/Login'
    }
  }, [_vm._v("Back to Login")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableButton
    }
  }, [_vm._v("Reset Password")])])])])])])]), _vm._v(" "), _c('alertModal', {
    attrs: {
      "visible": _vm.showModal,
      "title": 'Message',
      "message": _vm.message,
      "okText": 'OK',
      "ok": _vm.closeModalBasic
    },
    on: {
      "close": _vm.closeModalBasic
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px",
      "width": "auto"
    },
    attrs: {
      "src": __webpack_require__(17),
      "alt": "Image1"
    }
  })])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), (_vm.authenticated) ? _c('navbar', {
    attrs: {
      "show": true
    },
    on: {
      "logout": _vm.logout
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "approot"
  }), _vm._v(" "), (_vm.timesheetPage) ? _c('footer-bar', {
    attrs: {
      "show": false
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "save-fixed-btn"
  }, [(_vm.myTimesheetPage) ? _c('div', [((_vm.timesheetStatus.status === _vm.statusList.notSubmit && _vm.isMyTimesheet) || _vm.timesheetStatus.status === _vm.statusList.reject || (_vm.timesheetStatus.status === _vm.statusList.pending && _vm.isAdmin)) ? _c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.toCheckin
    }
  }, [_c('span', [_vm._v("Check in")])]) : _vm._e(), _vm._v(" "), ((_vm.timesheetStatus.status === _vm.statusList.notSubmit && _vm.isMyTimesheet) || _vm.timesheetStatus.status === _vm.statusList.reject || (_vm.timesheetStatus.status === _vm.statusList.pending && _vm.isAdmin)) ? _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.toCheckout
    }
  }, [_c('span', [_vm._v("Check out")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.toPreview
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _c('span', [_vm._v(" Preview")])]), _vm._v(" "), ((_vm.timesheetStatus.status === _vm.statusList.notSubmit && _vm.isMyTimesheet) || _vm.timesheetStatus.status === _vm.statusList.reject || (_vm.timesheetStatus.status === _vm.statusList.pending && _vm.isAdmin)) ? _c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.saveTimesheet
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(" Save")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.previewTimesheetPage) ? _c('div', [(_vm.isMyTimesheet && (_vm.timesheetStatus.status === _vm.statusList.notSubmit || _vm.timesheetStatus.status === _vm.statusList.reject)) ? _c('div', [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitTimesheet
    }
  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin && _vm.timesheetStatus.status === _vm.statusList.pending) ? _c('div', [_c('button', {
    staticClass: "button is-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.approveTimesheet
    }
  }, [_vm._v("Approve")]), _vm._v(" "), _c('button', {
    staticClass: "button is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rejectTimesheet
    }
  }, [_vm._v("Reject")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": __webpack_require__(17),
      "alt": _vm.description
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(17),
      "alt": _vm.pkginfo.description
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])])])])])
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [(_vm.tokenValid === 2) ? _c('div', [_c('h1', [_vm._v("This link is expired")])]) : (_vm.tokenValid === 1) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error) + "\n                ")]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('label', {
    staticClass: "label has-text-left"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('label', {
    staticClass: "label has-text-left"
  }, [_vm._v("Re-enter New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirmation password",
      "name": "confirm"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirm')),
      expression: "errors.has('confirm')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('confirm')))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableButton
    }
  }, [_vm._v("Change Password")])])])])])])]) : _vm._e()]), _vm._v(" "), _c('alertModal', {
    attrs: {
      "visible": _vm.showModal,
      "title": 'Message',
      "message": _vm.message,
      "okText": 'OK',
      "ok": _vm.closeModalBasic
    },
    on: {
      "close": _vm.closeModalBasic
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px",
      "width": "auto"
    },
    attrs: {
      "src": __webpack_require__(17),
      "alt": "Image1"
    }
  })])
}]}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    MENU\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', [(item.path && item.meta.roles && item.meta.roles.indexOf(_vm.role) != -1) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.path && item.meta.roles && item.meta.roles.indexOf(_vm.role) != -1) ? _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path && subItem.meta.roles && subItem.meta.roles.indexOf(_vm.role) != -1) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        },
        nativeOn: {
          "click": function($event) {
            return _vm.resetDateTime(subItem)
          }
        }
      }, [_vm._v("\n              " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n            ")])], 1) : _vm._e()
    }), 0)]) : _vm._e()], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PreviewTimesheet', {
    key: _vm.eventcount
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible,
      "title": _vm.title,
      "transition": "fade"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.message))])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))])])])])])
},staticRenderFns: []}

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-admin","version":"0.1.12","description":"Vue Admin Panel Framework","repository":"vue-bulma/vue-admin","homepage":"https://admin.vuebulma.com","license":"MIT","author":{"name":"Fangdun Cai","email":"cfddream@gmail.com","url":"fundon.me"},"keywords":["admin","bulma","dashboard","data","visualization","vue"],"engines":{"node":">=4","npm":">=3"},"scripts":{"build":"cross-env NODE_ENV=production node build/build.js","testing":"cross-env NODE_ENV=testing node build/build.js","uat":"cross-env NODE_ENV=uat node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","gh":"npm run build && gh-pages -d dist","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol"},"dependencies":{"@websanova/vue-auth":"^2.8.2-beta","animate.css":"3.5.2","animejs":"^2.2.0","axios":"^0.15.3","babel-runtime":"^6.26.0","bulma":"^0.3.2","font-awesome":"4.7.0","html2pdf.js":"^0.10.1","jquery":"^3.4.1","jspdf":"^2.5.1","mdi":"^1.8.36","moment":"^2.24.0","vee-validate":"2.0.0-rc.19","vue":"^2.6.10","vue-axios":"^2.1.4","vue-bulma-breadcrumb":"^1.0.1","vue-bulma-card":"^1.0.2","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"^1.3.6","vue-bulma-expanding":"^0.0.1","vue-bulma-message":"^1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-notification":"^1.1.1","vue-bulma-switch":"^1.0.5","vue-bulma-tooltip":"^1.0.3","vue-cleave":"^1.2.2","vue-events":"^3.1.0","vue-focus":"^2.1.0","vue-google-signin-button":"^1.0.4","vue-js-toggle-button":"^1.3.0","vue-nprogress":"^0.1.5","vue-numeric":"^2.3.0","vue-router":"^2.8.1","vue-select":"^2.5.1","vue-wysiwyg":"^1.7.2","vuex":"^2.5.0","vuex-router-sync":"^4.3.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.26.3","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-transform-export-extensions":"^6.8.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.7.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","connect-history-api-fallback":"^1.6.0","cross-env":"^3.1.3","css-loader":"^0.27.1","electron-devtools-installer":"^2.2.4","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.8.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.17.1","extract-text-webpack-plugin":"^2.0.0-rc.3","file-loader":"^0.10.1","html-webpack-plugin":"^2.30.1","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.12.0","opn":"^4.0.2","ora":"^1.1.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.12.1","sass-loader":"^6.0.3","serve-favicon":"^2.4.5","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-html-loader":"^1.2.3","vue-loader":"^11.1.4","vue-template-compiler":"^2.6.10","vuetable-2":"^1.6.6","webpack":"^2.2.1","webpack-dev-middleware":"^1.12.0","webpack-hot-middleware":"^2.25.0","webpack-merge":"^4.2.1"}}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(204);


/***/ }),
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/fontawesome-webfont.912ec66.svg";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/fonts/fontawesome-webfont.fee66e7.woff";

/***/ })
],[384]);


// WEBPACK FOOTER //
// assets/js/app.4a07e03a43ed61964afb.js